import React, { Fragment, useEffect, useState } from "react";
import {
    Container,
    DropdownMenu,
    DropdownToggle,
    Label,
    ModalBody,
    UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import InfoGif from "../../../assets/images/GIF/question-mark.gif";
import AccessDenied from "../../../assets/images/dribbble_1.gif";
import mauticImg from "../../../assets/images/Mautic_Logo_LB.png";
import meetIcon from "../../../assets/images/meeticon.png";
import usFlag from "../../../assets/images/flags/usa.png";
import ukFlag from "../../../assets/images/flags/uk.png";
import indiaFlag from "../../../assets/images/flags/india.png";
import canadaFlag from "../../../assets/images/flags/canadian_flag.jpg";
import "../../../assets/css/Sales/Lead.css";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Badge,
    Modal,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import Select from "react-select";
import sideImg from "../../../assets/images/profile-img.png";
// import ServerPagination from "components/Common/ServerPagination"

// assets
import "../../../assets/css/Sales/Sales.css";
import "../../../assets/css/Sales/Lead.css";

// common component
import Pagination from "components/Common/Pagination";
import ViewProfile from "./ViewLead/ViewProfile";
import ViewActivity from "./ViewLead/ViewActivity";
import ViewNotes from "./ViewLead/ViewNotes";
import Loader from "pages/Separate/Loader";
// Hover card
import { fetchData, FetchNodePostData } from "utils/common-fetchData";
import ViewFollowUp from "./ViewLead/ViewFollowUp";
import ViewProposals from "./ViewLead/ViewProposals";
import ViewContracts from "./ViewLead/ViewContracts";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Dropzone from "react-dropzone";
import swal from "sweetalert";
import moment from "moment";
import configure from "configure";
import Swal from "sweetalert2";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import AddMeeting from "./AddMeeting";
import AddTasks from "pages/Dashboard/GeneralTask/AddTasks";
import StageTracker from "components/Common/StageTracker";
import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import { Tooltip } from "antd";
import {
    convertTimeZone,
    getInitials,
    getLeadStatus,
    transformGeneralData,
} from "utils/common-helpers";
import secureLocalStorage from "react-secure-storage";
import NewPagination from "components/Common/Newpagination";
import ServerPagination from "components/Common/serverPagination";
import { priorityOption } from "utils/common-options";
import { map } from "lodash";
// import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels"

// ── Lead table formatting helpers (pure, module-level so they aren't
// recreated on every render) ────────────────────────────────────────────────
const formatLeadValue = (value, fallback = "-") =>
    value === null || value === undefined || value === "" || value === "undefined" || value === "null"
        ? fallback
        : value;

// Dates from the API come back as UTC ISO strings (e.g. "...T12:45:20.000Z");
// converting to IST explicitly keeps the displayed date/time correct
// regardless of the viewing browser's own local timezone setting.
const formatDate = (date, fmt = "DD MMM YYYY") =>
    date ? moment(date).tz("Asia/Kolkata").format(fmt) : "-";

const getActivityText = (row) => {
    // Same timestamp the date line above it displays (last_note_date) --
    // using a different field here (last_note_updated_at/updated_at) let
    // the "X ago" text disagree with the date actually shown next to it.
    const updatedDate = row?.last_note_date || row?.last_note_updated_at || row?.updated_at;
    return updatedDate ? `${moment(updatedDate).fromNow()}` : "No activity yet";
};

const LEAD_BELONGS_TO_FLAGS = {
    1: { src: "india", label: "India" },
    2: { src: "uk", label: "United Kingdom" },
    3: { src: "us", label: "United States" },
    4: { src: "canada", label: "Canada" },
};

const getLeadCountryFlag = (leadBelongsTo, flagImages) => {
    const meta = LEAD_BELONGS_TO_FLAGS[leadBelongsTo];
    if (!meta) return null;
    return { src: flagImages[meta.src], label: meta.label };
};

const parseStepStatus = (stepStatus) => {
    if (!stepStatus) return null;
    if (typeof stepStatus === "object") return stepStatus;
    try {
        return JSON.parse(stepStatus);
    } catch {
        return null;
    }
};

const Lead = () => {
    const [modal_fullscreen, setmodal_fullscreen] = useState(false);
    const [viewId, setViewId] = useState("");
    const [verticalActiveTab, setverticalActiveTab] = useState("5");
    const [data, setDatas] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    // const [isLoading, setLoading] = useState(false)
    const [country, setCountry] = useState("");
    const [source, setSource] = useState([]);
    const [status, setStatus] = useState([]);
    const [assign, setAssign] = useState([]);
    const [description, setDescription] = useState("");
    const [type, setType] = useState([]);
    const [industry, setIndustry] = useState([]);
    const [location, setLocation] = useState([]);
    const [sourceIn_option, setInSource] = useState([]);
    const [sourceuk_option, setUkSource] = useState([]);
    const [userIn_option, setUserIn] = useState([]);
    const [useruk_option, setUserUk] = useState([]);
    const [alluser_option, setAllUsers] = useState([]);
    const [allsource_option, setAllSource] = useState([]);
    const [status_option, setStatusOption] = useState([]);
    const [industry_option, setIndustryOption] = useState([]);
    const [convertBtn, setConvertBtn] = useState(false);
    // module_id=17 permission matrix (india/uk arrays, index = action type),
    // fetched once on mount and reused by every add/edit/delete permission
    // check below instead of each one re-fetching it over the network.
    const [permissions, setPermissions] = useState({ india: [], uk: [] });
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [total, setTotal] = useState(0);
    const [hotCount, setHotCount] = useState(0);
    const [warmCount, setWarmCount] = useState(0);
    const [coldCount, setColdCount] = useState(0);
    const [normalCount, setNormalCount] = useState(0);
    const [extremeHotCount, setExtremeHotCount] = useState(0);
    const [fullLeadData, setFullLeadData] = useState([]); // stores ALL 60000+ leads
    const [fullLeadLoading, setFullLeadLoading] = useState(true);
    const [loadingCounter, setLoadingCounter] = useState(0);
    const [isNote, setIsNote] = useState(false);
    const [isFollowup, setIsFollowup] = useState(false);
    const [filterFollowDate, setFilterFollowDate] = useState("");
    // const [leadTypeModal, setLeadTypeModal] = useState(false)
    // const [selectedLead, setSelectedLead] = useState(null)
    // const [selectedLeadType, setSelectedLeadType] = useState(null)
    const [selectedLead, setSelectedLead] = useState(null);
    const [openLeadTypeDropdownId, setOpenLeadTypeDropdownId] = useState(null);
    const [openStatusDropdownId, setOpenStatusDropdownId] = useState(null);
    const [initialFetched, setInitialFetched] = useState(false);
    const [currentFilters, setCurrentFilters] = useState({
        location: "",
        asigned: "",
        status: "",
        source: "",
        lead_type: "",
        industry: "",
        keyword: "",
    });

    const isLoading = loadingCounter > 0;

    const startLoading = () => setLoadingCounter((prev) => prev + 1);
    const stopLoading = () => setLoadingCounter((prev) => Math.max(prev - 1, 0));

    const replyMessage = [{}, {}, {}, {}, {}, {}, {}];

    useEffect(() => {
        FilterData();
        // fetch();
    }, []);

    useEffect(() => {
        if (initialFetched) onFilter();
    }, [initialFetched]);

    useEffect(() => {
        const handleOutsideClick = () => {
            setOpenLeadTypeDropdownId(null);
            setOpenStatusDropdownId(null);
        };

        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    // Live lead-list sync -- reacts to 'lead-changed' events dispatched by
    // utils/LeadRealtimeSync.js (subscribed in App.js) whenever any user
    // with lead-module access adds/edits/deletes/status-or-type-changes a
    // lead, so this list reflects it without a manual refresh. Not a
    // notification: no toast, no bell entry, just local state patched (or,
    // for a new lead, a silent re-fetch of the current page/filters --
    // whether a brand new lead belongs in view depends on filters the
    // backend already knows how to apply, so let it decide instead of
    // guessing here).
    useEffect(() => {
        const handleLeadChanged = (e) => {
            const { action, lead } = e.detail || {};
            if (!lead?.id) return;

            if (action === "deleted") {
                setDatas((prev) => prev.filter((item) => item.id !== lead.id));
                setDisplayData((prev) => prev.filter((item) => item.id !== lead.id));
                setTotal((prev) => Math.max(prev - 1, 0));
                return;
            }

            if (action === "created") {
                fetch(currentPage, limit, currentFilters.keyword, currentFilters);
                return;
            }

            // updated / status_changed / type_changed: patch in place if the
            // lead is part of the currently loaded page. If it isn't loaded,
            // there's nothing to patch here -- it'll reflect correctly next
            // time this page/filter is loaded.
            const patchLead = (item) => {
                if (item.id !== lead.id) return item;
                const patched = { ...item };
                if (lead.company !== undefined) patched.company = lead.company;
                if (lead.lead_type !== undefined) patched.lead_type = lead.lead_type;
                if (lead.status !== undefined) {
                    patched.status = lead.status;
                    patched.lead_status_id = lead.status;
                    const statusObj = status_option.find(
                        (opt) => String(opt.value) === String(lead.status),
                    );
                    if (statusObj) patched.sname = statusObj.label;
                }
                return patched;
            };

            setDatas((prev) => prev.map(patchLead));
            setDisplayData((prev) => prev.map(patchLead));
        };

        window.addEventListener("lead-changed", handleLeadChanged);
        return () => window.removeEventListener("lead-changed", handleLeadChanged);
    }, [currentPage, limit, currentFilters, status_option]);

    useEffect(() => {
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("module_id", 17);

        FetchNodePostData(
            null,
            "user_permission",
            localStorage.getItem("auth_token"),
            formData,
        ).then((res) => {
            setPermissions({
                india: res.data.data.india,
                uk: res.data.data.uk,
            });
            if (res.data.data.india[1] == 1 && res.data.data.uk[1] == 1) {
                setConvertBtn(true);
            } else {
                setConvertBtn(false);
            }
        }).catch((err) => console.log(err));
    }, []);

    const type_option = [
        { label: "Hot", value: "1" },
        { label: "Cold", value: "2" },
        { label: "Warm", value: "3" },
        { label: "Normal", value: "4" },
        { label: "Extreme Hot", value: "5" },
    ];

    const leadTypeModalOptions = [
        { label: "Hot", value: "Hot" },
        { label: "Cold", value: "Cold" },
        { label: "Warm", value: "Warm" },
        { label: "Normal", value: "Normal" },
        { label: "Extreme Hot", value: "Extreme Hot" },
        { label: "On Hold", value: "On Hold" },
    ];

    const HOLD_MONTH_OPTIONS = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December",
    ].map((label, idx) => ({ label, value: idx + 1 }));

    const HOLD_YEAR_OPTIONS = Array.from({ length: 6 }, (_, i) => {
        const year = new Date().getFullYear() + i;
        return { label: String(year), value: year };
    });

    const [leadType, setLeadType] = useState("");
    const [holdModalLead, setHoldModalLead] = useState(null);
    const [holdForever, setHoldForever] = useState(false);
    const [holdMonth, setHoldMonth] = useState(null);
    const [holdYear, setHoldYear] = useState(null);
    const [holdSaving, setHoldSaving] = useState(false);

    const openHoldModal = (lead) => {
        setOpenLeadTypeDropdownId(null);
        setOpenStatusDropdownId(null);
        setHoldModalLead(lead);
        setHoldForever(false);
        setHoldMonth(null);
        setHoldYear(null);
    };

    const closeHoldModal = () => {
        setHoldModalLead(null);
    };

    const handleConfirmHold = async () => {
        if (!holdModalLead) return;
        if (!holdForever && (!holdMonth || !holdYear)) {
            Swal.fire({ icon: "warning", text: "Select a month and year, or choose Forever Hold." });
            return;
        }

        setHoldSaving(true);

        try {
            const holdStatusOption = status_option.find(
                (item) => String(item.label).trim().toLowerCase() === "on hold",
            );

            const payload = {
                lead_id: holdModalLead.id,
                user_id: localStorage.getItem("auth_id"),
                hold_forever: holdForever,
                hold_until_month: holdForever ? null : holdMonth?.value,
                hold_until_year: holdForever ? null : holdYear?.value,
                status: holdStatusOption?.value,
            };

            const response = await FetchNodePostData(
                null,
                "editLead/updateHoldStatus",
                localStorage.getItem("auth_token"),
                payload,
            );

            const patchHold = (item) =>
                item.id === holdModalLead.id
                    ? {
                        ...item,
                        lead_type: "Cold",
                        on_hold: true,
                        hold_forever: holdForever,
                        hold_until_month: holdForever ? null : holdMonth?.value,
                        hold_until_year: holdForever ? null : holdYear?.value,
                        ...(holdStatusOption && {
                            lead_status_id: holdStatusOption.value,
                            status: holdStatusOption.value,
                            sname: holdStatusOption.label,
                        }),
                    }
                    : item;

            setDatas((prev) => prev.map(patchHold));
            setDisplayData((prev) => prev.map(patchHold));

            Swal.fire({
                icon: "success",
                text: response?.data?.message || "Lead moved to On Hold",
            });

            closeHoldModal();

            fetch(currentPage, limit, "", currentFilters);
        } catch (error) {
            console.log("Hold update error:", error?.response?.data || error);

            Swal.fire({
                icon: "error",
                text: error?.response?.data?.message || "Failed to move lead to On Hold",
            });
        } finally {
            setHoldSaving(false);
        }
    };

    const fetch = async (page = 1, limit = 50, keyword = "", filters = {}) => {
        startLoading();

        const {
            location = "",
            asigned = "",
            status = "",
            source = "",
            lead_type = "",
            industry = "",
        } = filters;

        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("location", location);
        formData.append("asigned", asigned);
        formData.append("status", status);
        formData.append("source", source);
        formData.append("lead_type", lead_type);
        formData.append("industry", industry);
        formData.append("page", page);
        formData.append("limit", limit);
        formData.append("keyword", keyword);

        try {
            const response = await FetchNodePostData(
                null,
                "all_lead",
                localStorage.getItem("auth_token"),
                formData,
            );

            setDisplayData(response.data.data);
            setDatas(response.data.data);
            setTotal(response.data.total);
            setHotCount(response.data.hotCount);
            setWarmCount(response.data.warmCount);
            setColdCount(response.data.coldCount);
            setNormalCount(response.data.normalCount);
            setExtremeHotCount(response.data.extremeHotCount);
            setCurrentPage(page);
            stopLoading();
        } catch (err) {
            console.log(err);
            stopLoading();
        }
    };

    // const toggleLeadTypeDropdown = lead => {
    //   setOpenLeadTypeDropdownId(prev => (prev === lead.id ? null : lead.id))
    // }

    // const toggleStatusDropdown = lead => {
    //   setOpenStatusDropdownId(prev => (prev === lead.id ? null : lead.id))
    // }

    const toggleLeadTypeDropdown = (lead) => {
        setOpenStatusDropdownId(null);
        setOpenLeadTypeDropdownId((prev) => (prev === lead.id ? null : lead.id));
    };

    const toggleStatusDropdown = (lead) => {
        setOpenLeadTypeDropdownId(null);
        setOpenStatusDropdownId((prev) => (prev === lead.id ? null : lead.id));
    };

    const handleLeadTypeChange = async (lead, nextLeadType) => {
        if (!lead || !nextLeadType) return;

        startLoading();

        try {
            const payload = {
                lead_id: lead.id,
                user_id: localStorage.getItem("auth_id"),
                lead_type: nextLeadType,
            };

            const response = await FetchNodePostData(
                null,
                "editLead/updateLeadType",
                localStorage.getItem("auth_token"),
                payload,
            );

            const patchLeadType = (item) =>
                item.id === lead.id
                    ? {
                        ...item,
                        lead_type: nextLeadType,
                    }
                    : item;

            setDatas((prev) => prev.map(patchLeadType));
            setDisplayData((prev) => prev.map(patchLeadType));
            setOpenLeadTypeDropdownId(null);

            Swal.fire({
                icon: "success",
                text: response?.data?.message || "Lead type updated successfully",
            });
        } catch (error) {
            console.log("Lead type update error:", error?.response?.data || error);

            Swal.fire({
                icon: "error",
                text: error?.response?.data?.message || "Failed to update lead type",
            });
        } finally {
            stopLoading();
        }
    };

    const handleStatusChange = async (leadId, nextStatus) => {
        if (!leadId || nextStatus === undefined || nextStatus === null) return;

        startLoading();

        const latestLead =
            data.find((item) => item.id === leadId) ||
            displayData.find((item) => item.id === leadId);

        if (!latestLead) {
            stopLoading();
            return;
        }

        const selectedStatusObj = status_option.find(
            (item) => String(item.value) === String(nextStatus),
        );

        try {
            const payload = {
                lead_id: latestLead.id,
                user_id: localStorage.getItem("auth_id"),
                status: nextStatus,
            };

            const response = await FetchNodePostData(
                null,
                "editLead/updateStatusType",
                localStorage.getItem("auth_token"),
                payload,
            );

            const patchRow = (item) =>
                item.id === leadId
                    ? {
                        ...item,
                        lead_status_id: nextStatus,
                        status: nextStatus,
                        sname: selectedStatusObj?.label || item.sname,
                    }
                    : item;

            setDatas((prev) => prev.map(patchRow));
            setDisplayData((prev) => prev.map(patchRow));

            setOpenStatusDropdownId(null);

            Swal.fire({
                icon: "success",
                text: response?.data?.message || "Status updated successfully",
            });
        } catch (error) {
            console.log("Status update error:", error?.response?.data || error);

            Swal.fire({
                icon: "error",
                text: error?.response?.data?.message || "Status update failed",
            });
        } finally {
            stopLoading();
        }
    };

    const [disable, setDiable] = useState(false);

    const FilterData = async () => {
        startLoading();
        try {
            const formData2 = new FormData();
            formData2.append("user_id", localStorage.getItem("auth_id"));

            // filter_data (dropdown option lists) and show_lead_filter (this
            // user's saved filter, if any) don't depend on each other's HTTP
            // call — only some of show_lead_filter's post-processing needs
            // filter_data's arrays. Firing them together instead of nesting
            // one inside the other's .then() removes a full round trip from
            // the critical path before the lead list itself can even start
            // loading (onFilter/fetch only fires once initialFetched flips,
            // right after this function finishes).
            const [response, response2] = await Promise.all([
                fetchData(
                    null,
                    "filter_data",
                    localStorage.getItem("auth_token"),
                ),
                FetchNodePostData(
                    null,
                    "show_lead_filter",
                    localStorage.getItem("auth_token"),
                    formData2,
                ),
            ]);

            setStatusOption(
                getLeadStatus(
                    response.data.data.lead_status.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
                ),
            );
            setInSource(
                response.data.data.india_source?.map((obj) => ({
                    value: obj.ids?.[0],
                    label: obj.leadname,
                })),
            );
            setUkSource(
                response.data.data.uk_source?.map((obj) => ({
                    value: obj.ids?.[0],
                    label: obj.leadname,
                })),
            );
            setUserIn(
                response.data.data.india_user.map((obj) => ({
                    value: obj.id,
                    label: obj.name,
                })),
            );
            setUserUk(
                response.data.data.uk_user.map((obj) => ({
                    value: obj.id,
                    label: obj.name,
                })),
            );

            const users = [
                ...response.data.data.uk_user,
                ...response.data.data.india_user,
            ];
            const source = [
                ...(response.data.data.india_source || []),
                ...(response.data.data.uk_source || []),
            ];
            const jsonObject = users.map(JSON.stringify);
            const uniqueSet = new Set(jsonObject);
            const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
            setAllUsers(
                uniqueArray.map((obj) => ({
                    value: obj.id,
                    label: obj.name,
                })),
            );

            const jsonObject1 = source.map(JSON.stringify);
            const uniqueSet1 = new Set(jsonObject1);
            const uniqueArray1 = Array.from(uniqueSet1).map(JSON.parse);
            setAllSource(
                uniqueArray1.map((obj) => ({
                    value: obj.ids?.[0],
                    label: obj.leadname,
                })),
            );
            setIndustryOption(
                response.data.data.industry?.map((obj) => ({
                    value: obj.id,
                    label: obj.name,
                })),
            );

            if (response2.data.success == false) {
                setDiable(true);
            }
            const datas = response2.data.data?.[0] || {};

            if (datas.location == "1") {
                setCountry({ label: "India", value: 1 });
            } else if (datas.location == "2") {
                setCountry({ label: "United Kingdom", value: 2 });
            }
            const sourceIds = datas?.source?.split(",").map(Number);
            const statusIds = datas?.status?.split(",").map(Number);
            const assignIds = datas?.assigned?.split(",").map(Number);
            const typeIds = datas?.lead_type?.split(",");
            const industryIds = datas?.industry?.split(",").map(Number);
            setSource(
                uniqueArray1
                    ?.filter((item) => item.ids?.some((id) => sourceIds?.includes(id)))
                    ?.map((obj) => ({
                        value: obj.ids?.[0],
                        label: obj.leadname,
                    })),
            );
            setStatus(
                getLeadStatus(
                    response.data.data?.lead_status
                        ?.filter((item) => statusIds?.includes(item.id))
                        ?.map((obj) => ({
                            value: obj.id,
                            label: obj.name,
                        })),
                ),
            );
            setAssign(
                uniqueArray
                    ?.filter((item) => assignIds?.includes(item.id))
                    ?.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
            );
            setType(type_option?.filter((item) => typeIds?.includes(item.value)));
            setIndustry(
                response.data.data?.industry
                    ?.filter((item) => industryIds?.includes(item.id))
                    ?.map((obj) => ({
                        value: obj.id,
                        label: obj.name,
                    })),
            );

            stopLoading();
        } catch (err) {
            console.log(err);
            stopLoading();
        } finally {
            setInitialFetched(true);
        }
    };

    const toggleVertical = (tab) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };

    const [lead_data, setLeadData] = useState([]);
    const [note_data, setNoteData] = useState([]);
    const [log_data, setLogData] = useState([]);
    const [follow_data, setFollowData] = useState([]);
    const [assigned_data, setAssignData] = useState([]);
    const [isFavorite, setIsFavorite] = useState(true);
    const [isFavoriteId, setIsFavoriteId] = useState(0);
    const [name_modal, setNameModal] = useState(false);

    // Lead -> RFP -> Proposal -> Contract -> Customer tracker (View Lead modal only)
    const [stageTracker, setStageTracker] = useState({ rfp: null, proposal: null, contract: null });
    // Which stage's details are shown inline in the View Lead modal (RFP only — Proposal/Contract open in a new tab)
    const [activeStageView, setActiveStageView] = useState(null);
    const fetchStageTracker = async (leadId) => {
        setStageTracker({ rfp: null, proposal: null, contract: null });
        setActiveStageView(null);
        const token = secureLocalStorage.getItem("auth_token");
        const get = async (path) => {
            try {
                const res = await fetchNodeData(
                    null,
                    `${path}/${leadId}`,
                    token,
                );
                return res?.data?.data || null;
            } catch (err) {
                console.log(err);
                return null;
            }
        };
        const [rfp, proposal, contract] = await Promise.all([
            get("get_rfp_by_lead"),
            get("get_proposal_by_lead"),
            get("get_contract_by_lead"),
        ]);
        setStageTracker({ rfp, proposal, contract });
    };

    //code for fetching lead data
    const followupdatacount = follow_data.length;
    const notesdatacount = note_data.length;
    // console.log("followupdatacount" ,followupdatacount)
    //  console.log("notesdatacount" ,notesdatacount)
    //meta title
    document.title = "Leads | Zithas Technologies";

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") setmodal_fullscreen(false);
    });

    const [view_assign, setViewAssign] = useState([]);
    const [created_at, setCreatedAt] = useState("");
    const [copiedId, setCopiedId] = useState(null);
    const toggleFavorite = async ({ leadId, fav }) => {
        swal({
            text: `${fav == 0
                ? "Are you sure you want to favorite this lead?"
                : "Are you sure you want to unfavorite this lead?"
                }`,
            icon: "warning",
            buttons: true,
        }).then(async (willOkay) => {
            if (willOkay) {
                setIsFavorite(!isFavorite); // Toggle favorite status
                const favValue = fav ? 0 : 1 || fav ? 1 : 0;
                setIsFavoriteId(fav);
                const formData = new FormData();
                formData.append("lead_id", leadId);
                formData.append("fav", favValue);
                formData.append("user_id", localStorage.getItem("auth_id"));
                formData.append("location", "");
                formData.append("asigned", "");
                formData.append("status", "");
                formData.append("source", "");
                startLoading();
                try {
                    const response = await FetchNodePostData(
                        null,
                        "isFavourite",
                        localStorage.getItem("auth_token"),
                        formData,
                    );
                    if (response) {
                        // console.log("isFavourite", response)
                        setDatas(response?.data?.data);
                        stopLoading();
                        // swal({
                        //   text: "FollowUp is completed",
                        //   icon: "success",
                        // }).then(() => {
                        //   setFollowUp(response.data.data)
                        // })
                    }
                    stopLoading();
                } catch (error) {
                    stopLoading();
                    console.log(error);
                }
            }
        });
    };

    const [copy, setCopy] = useState(null);

    const copyToClipBoard = async ({ text, id }) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopy(id);
            setTimeout(() => setCopy(null), 2000); // Reset after 2 secondsnull
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    // table columns
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                isInfoIcon: false,
                className: "text-center",
                Cell: (cellProps) => {
                    return (
                        <div className="d-flex align-items-center gap-2">
                            <button
                                className="btn border-0 p-0"
                                onClick={() =>
                                    toggleFavorite({
                                        leadId: cellProps.row.original.id,
                                        fav: cellProps.row.original.is_favourite,
                                    })
                                }
                            >
                                <i
                                    className={`bi fav-btn ${cellProps.row.original.is_favourite == 1
                                        ? "bi-star-fill text-star"
                                        : "bi-star"
                                        }`}
                                ></i>
                            </button>
                            <span>{cellProps.row.original.id}</span>
                        </div>
                    );
                },
            },
            {
                Header: "",
                accessor: "assigned",
                Cell: (cellProps) => {
                    return (
                        <div className="text-center d-flex align-items-center">
                            <div className="profileImg-box">
                                {cellProps.row.original.asigned_avatar ? (
                                    <img
                                        src={`${configure.imgUrl}${cellProps.row.original.asigned_avatar}`}
                                        alt=""
                                        className="assigned-img mx-1"
                                        height="16"
                                        width="16"
                                    />
                                ) : (
                                    <div
                                        className="defualt-img lead-row-avatar"
                                        title={cellProps.row.original.asigned || "Z"}
                                    >
                                        {getInitials(cellProps.row.original.asigned || "Z")}
                                    </div>
                                )}
                                <div className="profileImg-detail">
                                    <div className="overflow-hidden mb-0 card">
                                        <div className="bg-primary bg-soft">
                                            <div className="row">
                                                <div className="col-8">
                                                    <div className="text-primary text-start p-3">
                                                        <h5 className="text-primary ">
                                                            {cellProps.row.original.asigned}
                                                        </h5>
                                                        <p style={{ width: "200px" }}>
                                                            {cellProps.row.original.assign_designation}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="align-self-end col-4">
                                                    <img src={sideImg} alt="" className="img-fluid" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pt-0 mb-0 card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="avatar-md profile-user-wid mb-2">
                                                        {cellProps.row.original.asigned_avatar ? (
                                                            <img
                                                                src={`${configure.imgUrl}${cellProps.row.original.asigned_avatar}`}
                                                                alt=""
                                                                style={{ width: "100%", height: "100%" }}
                                                                className="img-thumbnail rounded-circle"
                                                            />
                                                        ) : (
                                                            <div
                                                                className="defualt-img"
                                                                style={{ height: 60, width: 60, fontSize: 24 }}
                                                                title={cellProps.row.original.asigned || "Z"}
                                                            >
                                                                {getInitials(
                                                                    cellProps.row.original.asigned || "Z",
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className=" text-start">
                                                        <div className="row">
                                                            <div className="pe-1 col-5">
                                                                <h5 className="font-size-12 mb-1">Join Date</h5>
                                                                <p className=" font-size-12 text-muted mb-0">
                                                                    {cellProps.row.original.join_date}
                                                                </p>
                                                            </div>
                                                            <div className="ps-0 col-7">
                                                                <h5 className="font-size-12 mb-1">Email</h5>
                                                                <p className=" font-size-12 text-muted mb-0">
                                                                    {cellProps.row.original.assign_email}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {cellProps.row.original.lead_belongs_to == 1 ? (
                                <img
                                    src={indiaFlag}
                                    className="mx-1 location-img lead-row-flag"
                                    alt="flag"
                                />
                            ) : cellProps.row.original.lead_belongs_to == 2 ? (
                                <img
                                    src={ukFlag}
                                    className="mx-1 location-img lead-row-flag"
                                    alt="flag"
                                />
                            ) : cellProps.row.original.lead_belongs_to == 3 ? (
                                <img
                                    src={usFlag}
                                    className="mx-1 location-img lead-row-flag"
                                    alt="flag"
                                />
                            ) : cellProps.row.original.lead_belongs_to == 4 ? (
                                <img
                                    src={canadaFlag}
                                    className="mx-1 location-img lead-row-flag"
                                    alt="flag"
                                />) : null}
                        </div>
                    );
                },
                isInfoIcon: true,
            },
            {
                Header: "Company",
                accessor: "company",
                isInfoIcon: true,
                className: "cursor-pointer",
                Cell: (cellProps) => {
                    const currentLeadType = cellProps.row.original?.lead_type || "Lead";
                    const tooltipContent = (
                        <>
                            <p style={{ color: "purple", marginBottom: 0 }}>
                                {currentLeadType} - Note:{" "}
                                {cellProps.row.original?.currentNotesCount ?? 0}
                            </p>
                            <p style={{ color: "purple", marginBottom: 0 }}>
                                {currentLeadType} - follow up:{" "}
                                {cellProps.row.original?.currentFollowupCount ?? 0}
                            </p>
                            <p style={{ color: "blue", marginBottom: 0 }}>
                                Total notes: {cellProps.row.original?.totalNotesCount ?? 0}
                            </p>
                            <p style={{ color: "blue", marginBottom: 0 }}>
                                Total follow up:{" "}
                                {cellProps.row.original?.totalFollowupCount ?? 0}
                            </p>
                        </>
                    );
                    return (
                        <div className="d-flex justify-space-between align-items-center">
                            <Tooltip
                                color={"#752b97"}
                                title={`Service : ${cellProps.row.original?.service != null
                                    ? cellProps.row.original?.service
                                    : "Not Defined"
                                    }`}
                            >
                                <div>
                                    {cellProps.row.original.company !== null
                                        ? cellProps.row.original.company
                                        : "-"}
                                </div>
                            </Tooltip>
                            <div className="lead-type-popover-wrap">
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleLeadTypeDropdown(cellProps.row.original);
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "start",
                                    }}
                                >
                                    <Tooltip
                                        color={"#f0e8f4"}
                                        title={
                                            openLeadTypeDropdownId === cellProps.row.original.id
                                                ? null
                                                : tooltipContent
                                        }
                                    >
                                        <span>
                                            {cellProps.row.original.lead_type == "Hot" ? (
                                                <i
                                                    className="bx bxs-hot"
                                                    style={{
                                                        fontSize: "18px",
                                                        lineHeight: "0",
                                                        color: "#FF5733",
                                                    }}
                                                ></i>
                                            ) : cellProps.row.original.lead_type == "Warm" ? (
                                                <i
                                                    className="bx bxs-flame"
                                                    style={{
                                                        fontSize: "20px",
                                                        lineHeight: "0",
                                                        color: "#fdab99",
                                                    }}
                                                ></i>
                                            ) : cellProps.row.original.lead_type == "Cold" ? (
                                                <i
                                                    className="bx bxs-sun"
                                                    style={{
                                                        fontSize: "20px",
                                                        lineHeight: "0",
                                                        color: "#4ab3ff",
                                                    }}
                                                ></i>
                                            ) : cellProps.row.original.lead_type == "Extreme Hot" ? (
                                                <i
                                                    className="mdi mdi-fire-alert"
                                                    style={{
                                                        fontSize: "20px",
                                                        lineHeight: "0",
                                                        color: "#ff0000ff",
                                                    }}
                                                ></i>
                                            ) : null}
                                        </span>
                                    </Tooltip>
                                    <span
                                        title="current status notes count"
                                        className="badge bg-success ms-1 rounded-circle  fw-bold"
                                    >
                                        {cellProps.row.original?.currentNotesCount ?? 0}
                                    </span>
                                </div>

                                {openLeadTypeDropdownId === cellProps.row.original.id && (
                                    <div
                                        className="lead-type-popover-box"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {leadTypeModalOptions.map((item) => {
                                            const isActive =
                                                item.value === "On Hold"
                                                    ? Boolean(cellProps.row.original.on_hold)
                                                    : cellProps.row.original.lead_type === item.value &&
                                                    !cellProps.row.original.on_hold;

                                            return (
                                                <div
                                                    key={item.value}
                                                    onClick={() =>
                                                        item.value === "On Hold"
                                                            ? openHoldModal(cellProps.row.original)
                                                            : handleLeadTypeChange(
                                                                cellProps.row.original,
                                                                item.value,
                                                            )
                                                    }
                                                    className={`lead-type-option ${isActive ? "active" : ""
                                                        }`}
                                                >
                                                    {item.label}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                },
            },
            {
                Header: "Name",
                accessor: "person_details",
                isInfoIcon: true,
                Cell: (cellProps) => {
                    const raw = cellProps?.row?.original?.person_details;

                    let personal = [];

                    try {
                        if (typeof raw === "string" && raw.trim() !== "") {
                            personal = JSON.parse(raw);
                        } else if (Array.isArray(raw)) {
                            personal = raw;
                        }
                    } catch (error) {
                        console.warn("Invalid JSON:", raw);
                        personal = [];
                    }

                    let PersonName = "-";

                    if (Array.isArray(personal) && personal.length > 0) {
                        PersonName = personal[0]?.person_name || "-";
                    }

                    return <div>{PersonName}</div>;
                },
            },
            {
                Header: "Email / Phone",
                accessor: "email",
                isInfoIcon: true,
                Cell: (cellProps) => {
                    const alldata = cellProps?.row?.original;

                    const email = alldata?.person_details
                        ? JSON.parse(alldata.person_details)[0]?.person_email
                            ? JSON.parse(alldata.person_details)[0].person_email
                            : alldata?.email != null
                                ? alldata?.email
                                : "-"
                        : alldata?.email != null
                            ? alldata?.email
                            : "-";

                    const phone = alldata?.person_details
                        ? JSON.parse(alldata.person_details)[0]?.person_phone
                            ? JSON.parse(alldata.person_details)[0].person_phone
                            : alldata?.phonenumber != null
                                ? alldata?.phonenumber
                                : "-"
                        : alldata?.phonenumber != null
                            ? alldata?.phonenumber
                            : "-";

                    const CopyableLine = ({ value, copyId, emphasize }) =>
                        value && value != "-" ? (
                            <div className="d-flex justify-content-between">
                                <span className={emphasize ? "lead-phone-highlight" : ""}>
                                    {value}
                                </span>
                                <span>
                                    <i
                                        className={`ps-3 bi ${copyId == copy
                                            ? "bi-check"
                                            : "bi-clipboard label-icon"
                                            } label-icon`}
                                        style={{
                                            cursor: "pointer",
                                            color: "#a8a6a6",
                                            fontSize: "11px",
                                        }}
                                        onClick={() =>
                                            copyToClipBoard({
                                                text: value,
                                                id: copyId,
                                            })
                                        }
                                        title="Click to Copy"
                                    ></i>
                                </span>
                            </div>
                        ) : (
                            <div>-</div>
                        );

                    return (
                        <div>
                            <CopyableLine value={email} copyId={`1-${alldata.id}`} />
                            <CopyableLine value={phone} copyId={`2-${alldata.id}`} emphasize />
                        </div>
                    );
                },
            },
            {
                Header: "Source",
                accessor: "source",
                isInfoIcon: true,
                className: "text-center",
            },
            {
                Header: "Status",
                accessor: "status",
                className: "text-start",
                Cell: (cellProps) => {
                    return (
                        <div className="lead-type-popover-wrap">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                {/* CLICKABLE BADGE */}
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleStatusDropdown(cellProps.row.original);
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Badge className={`${cellProps.row.original.status_color} lead-status-badge`} pill>
                                        {formatLeadValue(cellProps.row.original.sname, "Unknown")}
                                    </Badge>
                                </div>

                                {cellProps.row.original.on_hold ? (
                                    <div
                                        className="text-muted text-center"
                                        title={
                                            cellProps.row.original.hold_forever
                                                ? "On Hold forever"
                                                : `On Hold until ${HOLD_MONTH_OPTIONS.find(
                                                      (m) => m.value === cellProps.row.original.hold_until_month,
                                                  )?.label || ""} ${cellProps.row.original.hold_until_year || ""}`
                                        }
                                        style={{ fontSize: "9px", lineHeight: "1.2", marginTop: "2px" }}
                                    >
                                        {cellProps.row.original.hold_forever
                                            ? "Forever"
                                            : cellProps.row.original.hold_until_month && cellProps.row.original.hold_until_year
                                            ? `${HOLD_MONTH_OPTIONS.find(
                                                  (m) => m.value === cellProps.row.original.hold_until_month,
                                              )?.label?.slice(0, 3) || ""} ${cellProps.row.original.hold_until_year}`
                                            : null}
                                    </div>
                                ) : null}
                            </div>

                            {/* DROPDOWN */}
                            {openStatusDropdownId === cellProps.row.original.id && (
                                <div
                                    className="lead-type-popover-box"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {status_option.map((item) => {
                                        const isHoldOption =
                                            String(item.label).trim().toLowerCase() === "on hold";
                                        const isActive = isHoldOption
                                            ? Boolean(cellProps.row.original.on_hold)
                                            : cellProps.row.original.lead_status_id === item.value;

                                        return (
                                            <div
                                                key={item.value}
                                                onClick={() =>
                                                    isHoldOption
                                                        ? openHoldModal(cellProps.row.original)
                                                        : handleStatusChange(
                                                            cellProps.row.original.id,
                                                            item.value,
                                                        )
                                                }
                                                className={`lead-type-option ${isActive ? "active" : ""
                                                    }`}
                                            >
                                                {item.label}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Current Stage",
                accessor: "current_stage",
                className: "text-start",
                Cell: (cellProps) => (
                    <StageTracker stages={getRowStages(cellProps.row.original)} dots />
                ),
            },
            {
                Header: "Activity",
                accessor: "last-reply",
                isInfoIcon: true,
                className: "text-start",
                Cell: ({ row }) => {
                    const original = row?.original;
                    const date = original?.last_note_date;
                    const notesCount = original?.total_notes ?? 0;
                    const followupsCount = original?.followup_logs_count ?? 0;

                    return (
                        <div style={{ minWidth: "130px" }}>
                            <div>{formatDate(date)}</div>
                            <div className="lead-activity-ago">{getActivityText(original)}</div>
                            {(notesCount > 0 || followupsCount > 0) && (
                                <div className="text-muted lead-meta-line d-flex align-items-center gap-2">
                                    <span title="Notes">
                                        <i className="fas fa-file-alt me-1"></i>
                                        {notesCount}
                                    </span>
                                    <span title="Follow-ups">
                                        <i className="fas fa-bell me-1"></i>
                                        {followupsCount}
                                    </span>
                                </div>
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "action",
                className: "text-center",
                Cell: (cellProps) => {
                    const onDeletePermission = () => {
                        if (permissions.india[5] == 1 || permissions.uk[5] == 1) {
                            onDeleteLead();
                        } else {
                            setAccessDenied(true);
                        }
                    };

                    const onDeleteLead = (e) => {
                        swal({
                            title: "Are you sure?",
                            text: "You want to Delete this Lead !",
                            icon: "warning",
                            buttons: true,
                            dangerMode: true,
                        }).then(async (willDelete) => {
                            if (willDelete) {
                                startLoading();
                                const formEntires = {
                                    id: cellProps.row.original.id,
                                    user_id: localStorage.getItem("auth_id"),
                                };
                                try {
                                    const response = await axios({
                                        method: "post",
                                        url: `${configure.nodeApi}/delete_lead`,
                                        data: formEntires,
                                        headers: {
                                            Accept: "application/json",
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }).then((response) => {
                                        swal({
                                            icon: "success",
                                            text: "Lead Deleted Successfully",
                                        }).then((data) => {
                                            fetch(currentPage, limit, "", currentFilters);
                                        });
                                        stopLoading();
                                    });
                                } catch (err) {
                                    swal({
                                        icon: "error",
                                        text: "Something went wrong",
                                    });
                                    stopLoading();
                                }
                            }
                        });
                    };

                    const fetch2 = async (id) => {
                        setCreatedAt(cellProps.row.original.created_at);
                        setViewId(id);
                        startLoading();
                        setmodal_fullscreen(true);
                        setverticalActiveTab("5");
                        const formData = new FormData();
                        formData.append("lead_id", cellProps.row.original.id);
                        formData.append("user_id", localStorage.getItem("auth_id"));
                        try {
                            const response = await axios({
                                method: "post",
                                url: `${configure.nodeApi}/all_lead_data`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((response) => {
                                setLeadData(response.data.data.lead);
                                setNoteData(response.data.data.lead_note);
                                setLogData(response.data.data.lead_activity?.reverse());
                                setFollowData(response.data.data.lead_followup_data);
                                setAssignData(response.data.data?.assigned);
                                console.log(
                                    "Followup Data of lead of",
                                    cellProps.row.original.id,
                                    response.data.data.lead_followup_data,
                                );
                                setViewAssign(
                                    response.data.data.assigned?.map((obj) => ({
                                        value: obj.id,
                                        label: obj.name,
                                    })),
                                );

                                fetchStageTracker(cellProps.row.original.id);

                                stopLoading();
                            });
                        } catch (err) {
                            console.log(err);
                            stopLoading();
                        }
                    };

                    const fetch3 = async (id) => {
                        setCreatedAt(cellProps.row.original.created_at);
                        // setViewId(id)
                        startLoading();
                        // setmodal_fullscreen(true)
                        const formData = new FormData();
                        formData.append("lead_id", cellProps.row.original.id);
                        formData.append("user_id", localStorage.getItem("auth_id"));
                        try {
                            const response = await axios({
                                method: "post",
                                url: `${configure.nodeApi}/all_lead_data`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((response) => {
                                setLeadData(response.data.data.lead);
                                setNoteData(response.data.data.lead_note);
                                setLogData(response.data.data.lead_activity?.reverse());
                                setFollowData(response.data.data.lead_followup_data);
                                setAssignData(response.data.data?.assigned);
                                console.log(
                                    "Followup Data of lead of",
                                    cellProps.row.original.id,
                                    response.data.data.lead_followup_data,
                                );
                                // setViewAssign(
                                //   response.data.data.assigned?.map(obj => ({
                                //     value: obj.id,
                                //     label: obj.name,
                                //   }))
                                // )

                                stopLoading();
                            });
                        } catch (err) {
                            console.log(err);
                            stopLoading();
                        }
                    };

                    const onConvert = async (e) => {
                        startLoading();
                        const formData = new FormData();
                        formData.append("lead_id", cellProps.row.original.id);
                        try {
                            const response = await axios({
                                method: "post",
                                url: `${configure.nodeApi}/convert_to_customer`,
                                data: formData,
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                },
                            }).then((response) => {
                                swal({
                                    icon: "success",
                                    text: "Converted Successfully",
                                }).then((data) => {
                                    navigate(
                                        `${configure.appUrl}sales/edit-customer/${response.data.data.id}`,
                                    );
                                });

                                stopLoading();
                            });
                        } catch (err) {
                            console.log(err);
                            stopLoading();
                        }
                    };

                    const onEditPermission = ({ id, isEditType }) => {
                        if (permissions.india[4] == 1 || permissions.uk[4] == 1) {
                            if (isEditType == 1) {
                                navigate(`${configure.appUrl}sales/edit-lead/${id}`);
                            } else {
                                onConvert();
                            }
                        } else {
                            setAccessDenied(true);
                        }
                    };

                    // const copyFon = alldata => {
                    //   let phone = ""

                    //   if (alldata?.person_details) {
                    //     try {
                    //       const parsed = JSON.parse(alldata.person_details)
                    //       if (parsed?.[0]?.person_phone) {
                    //         phone = parsed[0].person_phone
                    //       }
                    //     } catch (e) {
                    //       console.error("Invalid JSON in person_details")
                    //     }
                    //   }

                    //   if (!phone && alldata?.phonenumber != null) {
                    //     phone = alldata.phonenumber
                    //   }

                    //   if (!phone) return

                    //   navigator.clipboard.writeText(phone)

                    //   // setCopiedId(alldata.id);
                    //   // setTimeout(() => setCopiedId(null), 1500);
                    // }

                    const token = secureLocalStorage.getItem("auth_token");
                    const onSendRequest = async () => {
                        const formEntires = {
                            lead_id: cellProps?.row?.original?.id,
                            status: 1,
                        };
                        // const res = await FetchNodePostData(
                        //   setLoading,
                        //   "leadCOPstatus",
                        //   token,
                        //   formEntires
                        // )

                        const res = await axios({
                            method: "post",
                            url: `${configure.nodeApi}/leadCOPstatus`,
                            data: formEntires,
                        });

                        if (res?.data?.success) {
                            Swal.fire({
                                icon: "success",
                                text: "Request has been sent successfully",
                            });
                        }
                    };

                    return (
                        <div className="d-flex">
                            <a
                                title="add note"
                                className="btn btn-sm btn-outline-secondary me-1"
                                onClick={() => {
                                    setIsNote(false);
                                    fetchCurrency(
                                        cellProps.cell?.row?.original.id,
                                        cellProps.cell?.row?.original,
                                    );
                                    // fetchCurrency(cellProps.cell?.row?.original.id)
                                    setLeadId(cellProps.cell?.row?.original.id);
                                }}
                            >
                                <i className="fas fa-file-alt "></i>
                            </a>

                            <a
                                title="add followup"
                                className="btn btn-sm btn-outline-secondary me-1"
                                onClick={() => {
                                    setFollowupSideBar(true);
                                    fetch3(cellProps.cell?.row?.original.id);
                                    // fetchCurrency(
                                    //   cellProps.cell?.row?.original.id,
                                    //   cellProps.cell?.row?.original
                                    // )
                                    // fetchCurrency(cellProps.cell?.row?.original.id)
                                    setLeadId(cellProps.cell?.row?.original.id);
                                }}
                            >
                                <i className="fas fa-bell"></i>
                            </a>

                            <a
                                title="view lead"
                                className="btn btn-sm btn-outline-secondary me-1"
                                onClick={() => fetch2(cellProps.cell?.row?.original.id)}
                            >
                                <i className="fas fa-eye "></i>
                            </a>
                            <UncontrolledDropdown
                                className="dropdown"
                                style={{ width: "29px" }}
                            >
                                <DropdownToggle
                                    className="btn btn-sm btn-outline-secondary w-100"
                                    color="white"
                                >
                                    <i className="mdi mdi-dots-horizontal"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <a
                                        onClick={() =>
                                            onEditPermission({
                                                id: cellProps.cell.row.original.id,
                                                isEditType: 1,
                                            })
                                        }
                                        title="edit lead"
                                        className="dropdown-item"
                                    >
                                        <i className="fas fa-pencil-alt pr-10"></i> Edit Lead
                                    </a>



                                    {convertBtn ? (
                                        <>
                                            {cellProps.cell?.row?.original?.ctp_status == 4 ? (
                                                <Link
                                                    to={`${configure.appUrl}customer-onboarding/${cellProps.cell?.row?.original?.temp_customer}`}
                                                    className="dropdown-item"
                                                >
                                                    <i className="fas fa-exchange-alt text-success pr-10"></i>{" "}
                                                    Customer Onboarding
                                                </Link>
                                            ) : cellProps.cell?.row?.original?.ctp_status == 0 ? (
                                                <a
                                                    className="dropdown-item"
                                                    onClick={() => onSendRequest()}
                                                >
                                                    <i className="bx bx-log-in-circle text-success pr-10"></i>{" "}
                                                    Request for Invoice
                                                </a>
                                            ) : null}
                                        </>
                                    ) : null}
                                    <a
                                        onClick={() => onDeletePermission()}
                                        className="dropdown-item"
                                        title="delete"
                                    >
                                        <i className="fas fa-trash-alt pr-10 text-danger"></i>{" "}
                                        Delete Lead
                                    </a>
                                    <a
                                        className="dropdown-item"
                                        title="Create a meeting"
                                        // onClick={() => {
                                        //   redirectCalender()
                                        // }}
                                        href={`${configure.appUrl}calender/lead-${cellProps.cell.row.original.id}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <i className="fa fa-users me-2"></i>
                                        Add Meeting
                                    </a>

                                    <Link
                                        to={`${configure.appUrl}request-for-proposal/${cellProps.cell?.row?.original?.id}`}
                                        className="dropdown-item"
                                    >
                                        <i className="fas fa-exchange-alt text-success pr-10"></i>{" "}
                                        Request For Proposal
                                    </Link>

                                    <a
                                        className="dropdown-item"
                                        title="create task"
                                        onClick={() => {
                                            setLeadId(cellProps.cell?.row?.original.id);
                                            setAddTaskModal(true);
                                        }}
                                    >
                                        <i className="fas fa-tasks pr-10"></i>{" "}
                                        Create Task
                                    </a>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            {cellProps.row.original.mautic == 1 &&
                                cellProps.row.original.is_valid == 1 && (
                                    <div className="d-flex justify-content-center ps-1 align-items-center">
                                        <img
                                            src={mauticImg}
                                            width={23}
                                            height={23}
                                            alt="mautic"
                                            className="img-fluid"
                                        />
                                    </div>
                                )}
                        </div>
                    );
                },
            },
        ],
        [
            convertBtn,
            permissions,
            openLeadTypeDropdownId,
            openStatusDropdownId,
            status_option,
            currentPage,
            limit,
            currentFilters,
            copy,
        ],
    );

    const [formPopup, setFormPopup] = useState(false);
    const [fixedContent, setFixedContent] = useState(false);

    const navigate = useNavigate();

    document.addEventListener("scroll", () => {
        if (window.scrollY > 165) {
            setFixedContent(true);
        } else {
            setFixedContent(false);
        }
    });

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        setPageSize,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageIndex: 0,
            },
        },
        useGlobalFilter,
        usePagination,
    );

    useEffect(() => setPageSize(50), []);

    const colourStyles = {
        menuList: (styles) => ({
            ...styles,
            background: "white",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 1200,
        }),
    };

    useEffect(() => {
        fetchAllData();
        fetchCountry();
    }, []);

    const fetchCountry = async () => {
        startLoading();
        try {
            await axios({
                method: "get",
                url: `${configure.nodeApi}/locations`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                setLocation(
                    res.data.locations.map((obj) => ({
                        label: obj.location,
                        value: obj.id,
                    })),
                );
                stopLoading();
            });
        } catch (error) {
            console.log(error);
            stopLoading();
        }
    };

    const onFilter = async (e, lead_type = null) => {
        if (e) e.preventDefault();
        setFormPopup(false);
        startLoading();

        const Assign = assign.map((obj) => obj.value).join(",");
        const Status = status.map((obj) => obj.value).join(",");
        const Source = source.map((obj) => obj.value).join(",");
        const Type = lead_type || type.map((obj) => obj.label).join(","); // or .value if needed
        const Industry = industry.map((obj) => obj.value).join(",");

        const newFilters = {
            location: country?.value || "",
            asigned: Assign,
            status: Status,
            source: Source,
            lead_type: Type,
            industry: Industry,
            keyword: "",
        };

        setCurrentFilters(newFilters); // Save filters
        await fetch(1, limit, "", newFilters); // Reset to page 1
        stopLoading();
    };

    const [title, setTitle] = useState("");

    const info = [
        {
            title: "Assigned",
            mean: " <p> <strong>Meaning :</strong> In the Mars System's Lead Module, the <strong>Assigned</strong> column designates the specific team member or individual responsible for overseeing and taking action on a lead or potential business opportunity. </p>",
            purpose:
                " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong> column in the Lead Module is to assign clear accountability for each lead. By identifying who is responsible for nurturing and converting leads into customers, it streamlines lead management, ensures follow-up, and enhances the chances of successful lead conversion. This fosters a more efficient and organized approach to lead handling within the Mars System.</p>",
        },
        {
            title: "Company",
            mean: "<p><strong>Meaning :</strong>  Within the Mars System's Lead Module, the <strong>Company</strong> column refers to the name of the organization or business entity associated with a lead or potential opportunity</p>",
            purpose:
                "<p> <strong>Purpose :</strong> The purpose of the <strong>Company</strong> column is to provide crucial information about the lead's affiliation. It helps in categorizing leads by their company, allowing sales and marketing teams to tailor their strategies and messaging accordingly. This column streamlines lead segmentation and ensures that leads from the same company are managed cohesively, enhancing the effectiveness of lead conversion efforts.</p>",
        },
        {
            title: "Name",
            mean: "<p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Name</strong> column typically represents the full name of an individual associated with a lead or potential business opportunity.. </p>",
            purpose:
                "</strong> <p> <strong>Purpose :</strong> The purpose of the <strong>Name</strong> column is to provide specific information about the person linked to the lead. It allows for personalized communication and relationship-building with leads.</p>",
        },
        {
            title: "Email / Phone",
            mean: "<p><strong>Meaning :</strong>  The <strong>Email / Phone</strong> column shows the email address and phone number of the individual associated with a lead or potential business opportunity.</p>",
            purpose:
                "<p><strong>Purpose :</strong> The purpose of the <strong>Email / Phone</strong> column is to serve as a direct means of communication with leads. It ensures that users have a reliable channel to reach out to leads, fostering efficient communication and nurturing relationships to move leads further down the sales funnel.</p>",
        },
        {
            title: "Activity",
            mean: "<p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Activity</strong> column shows the date of the last note/reply on a lead, along with how many days have passed since the lead was last updated.</p>",
            purpose:
                "<p><strong>Purpose :</strong> The purpose of the <strong>Activity</strong> column is to provide a time-based reference for lead recency. It helps users understand how long it's been since a lead was actioned, so they can prioritize leads that need immediate follow-up or reevaluation.</p>",
        },
        {
            title: "Status",
            mean: "<p><strong>Meaning :</strong>  In the Mars System's Lead Module, the <strong>Status</strong> column indicates the current stage or status of a lead's progression within the lead management process</p>",
            purpose:
                "<p><strong>Purpose :</strong>  The purpose of the  <strong>Status</strong> column is to provide a clear overview of where each lead stands in the sales or conversion pipeline. It allows users to track and manage leads efficiently by categorizing them into stages such as  <strong>New </strong> ,  <strong>Contacted </strong>,  <strong>Qualified </strong>,  <strong>Negotiating </strong>, or  <strong>Closed</strong>. This status tracking facilitates better lead prioritization, workflow management, and decision-making, helping teams focus their efforts on leads at the appropriate stage of the sales cycle.</p>",
        },
        {
            title: "Current Stage",
            mean: "<p><strong>Meaning :</strong>  The <strong>Current Stage</strong> column shows where a lead currently sits in the Lead → RFP → Proposal → Contract → Customer pipeline, and how many days it has spent in that stage.</p>",
            purpose:
                "<p><strong>Purpose :</strong> The purpose of the <strong>Current Stage</strong> column is to give an at-a-glance view of pipeline progress, so users can spot leads that have been stuck in a stage too long and need follow-up.</p>",
        },
    ];

    const [modal_Access, setAccessDenied] = useState(false);

    // Quick Note Functionality

    const [currency_option, setCurrencyOption] = useState([]);
    const [allNotes, setAllNotes] = useState([]);
    const [lead_id, setLeadId] = useState("");
    const [leadDetail, setLeadDetail] = useState({});
    // const toggleLoading = loading => {
    //   setLoading(loading)
    // }

    const fetchCurrency = async (id, obj) => {
        setIsNote(false);
        setNotesSidebar(true);
        const personal = JSON?.parse(obj?.person_details);
        let PersonName;
        if (personal != null && personal?.length == 0) {
            PersonName = "-";
        } else if (personal != null) {
            PersonName = personal[0]?.person_name;
        }
        const newObj = { ...obj, personName: PersonName };
        setLeadDetail(newObj);
        setCurrencyOption([]);
        setAllNotes([]);
        // const response = await fetchData(toggleLoading, `leadNotesData/${id}`, "")
        try {
            startLoading();
            const response = await axios({
                method: "get",
                url: `${configure.nodeApi}/leadNotesData?lead_id=${id}`,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response?.data?.status) {
                setCurrencyOption(
                    response?.data?.data.currency.map((item) => ({
                        label: item.currency,
                        value: item.id,
                    })),
                );

                setAllNotes(response?.data.data.notes);
            } else {
                setCurrencyOption([]);
                setAllNotes([]);
            }
        } catch (error) {
            setCurrencyOption([]);
            setAllNotes([]);
        } finally {
            stopLoading();
        }
    };

    const [selectedFiles1, setselectedFiles1] = useState([]);

    function handleAcceptedFiles1(files) {
        files.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size),
            }),
        );
        setselectedFiles1(files);
    }

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    const [notesSidebar, setNotesSidebar] = useState(false);
    const [followupSidebar, setFollowupSideBar] = useState(false);

    const [currency, setCurrency] = useState({
        label: null,
        value: null,
    });
    const curentDateTime = moment().format("YYYY-MM-DDTHH:mm");
    const [notedate, setNotedate] = useState(curentDateTime);
    // const [assign, setAssigned] = useState([])
    const [amount, setAmount] = useState("");
    const [ckedata, setCkedata] = useState("");
    const [noDrag, setNoDrag] = useState(false);
    const [noteForm, setNoteForm] = useState(false);
    const [boxWidth, setBoxWidth] = useState(0);
    const [boxHeight, setBoxHeight] = useState(0);

    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth;
            setBoxWidth(viewportWidth * 0.9);
        };
        const updateHeight = () => {
            const viewpoirtHeight = window.innerHeight;
            setBoxHeight(viewpoirtHeight * 0.7);
        };
        updateHeight();
        updateWidth();
        window.addEventListener("resize", updateWidth, updateHeight);
        return () =>
            window.removeEventListener("resize", updateWidth, updateHeight);
    }, []);

    // add notes api
    const addNotes = async (e) => {
        e.preventDefault();
        // 🔥 Confirmation popup
        const resultConfirm = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this Note?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#6f42c1",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, add it!",
        });

        if (!resultConfirm.isConfirmed) return;

        startLoading();
        const formData = new FormData();

        if (isNote) {
            formData.append("related_id", lead_id);
            formData.append("related_to", "lead");
            formData.append("related", "sales");
            formData.append("type", 2);
            formData.append("copynotes", true);
            formData.append("title", taskName);
            formData.append("priority", priority.value);
            formData.append("assigned", assignee.value);
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("description", ckedata);
            formData.append("currency", currency.value != null ? currency.value : "");
            formData.append("date", notedate);
            formData.append("amount", amount);
        } else {
            formData.append("lead_id", lead_id);
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("currency", currency.value != null ? currency.value : "");
            formData.append("date", notedate);
            formData.append("amount", amount);
            formData.append("description", ckedata);
        }
        for (let i = 0; i < selectedFiles1.length; i++) {
            formData.append("files[]", selectedFiles1[i]);
        }
        try {
            if (isNote) {
                const response = await axios({
                    method: "post",
                    url: `${configure.nodeApi}/addGeneralTasks`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                });
                console.log("response: ", response);
                if (response) {
                    stopLoading();
                    Swal.fire({
                        icon: "success",
                        text: "Task & Note Added Successfully",
                    }).then((data) => {
                        setCkedata("");
                        setAmount("");
                        setNotesSidebar(false);
                        setIsNote(false);
                        setTaskName("");
                        setPriority([]);
                        setAssignee([]);
                        setCurrency({
                            label: null,
                            value: null,
                        });
                        setNotedate([]);
                        setselectedFiles1([]);
                        fetch(currentPage, limit, "", currentFilters);
                    });
                }
            } else {
                const response = await axios({
                    method: "post",
                    url: `${configure.nodeApi}/add_lead_note`,
                    data: formData,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                });

                const resData = response.data;
                stopLoading();

                if (resData.success === false && resData.ai_blocked === true) {
                    const result = await Swal.fire({
                        icon: "warning",
                        title: "Quality Check Failed",
                        html: `<p>${resData.message}</p><br/><small style="color:#666">${resData.ai_feedback}</small>`,
                        showCancelButton: true,
                        confirmButtonText: "Save Anyway",
                        cancelButtonText: "Go Back & Edit",
                        confirmButtonColor: "#f39c12",
                    });

                    if (result.isConfirmed) {
                        formData.append("ai_override", "true");
                        startLoading();
                        await axios({
                            method: "post",
                            url: `${configure.nodeApi}/add_lead_note`,
                            data: formData,
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "multipart/form-data",
                            },
                        });
                        stopLoading();
                        Swal.fire({
                            icon: "success",
                            text: "Note Added Successfully",
                        }).then(() => {
                            setCkedata("");
                            setAmount("");
                            setNotedate(curentDateTime);
                            setCurrency({ label: null, value: null });
                            setselectedFiles1([]);
                            fetch(currentPage, limit, "", currentFilters);
                            setNotesSidebar(false);
                        });
                    }
                } else {
                    Swal.fire({
                        icon: "success",
                        text: "Note Added Successfully",
                    }).then(() => {
                        setCkedata("");
                        setAmount("");
                        setNotedate(curentDateTime);
                        setCurrency({ label: null, value: null });
                        setselectedFiles1([]);
                        fetch(currentPage, limit, "", currentFilters);
                        setNotesSidebar(false);
                    });
                }
            }
        } catch (error) {
            console.log(error);
            stopLoading();
        }
    };

    const refreshLeadDetail = async (id) => {
        try {
            const formData = new FormData();
            formData.append("lead_id", id);
            formData.append("user_id", localStorage.getItem("auth_id"));
            const response = await axios({
                method: "post",
                url: `${configure.nodeApi}/all_lead_data`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            });
            setFollowData(response.data.data.lead_followup_data);
            setNoteData(response.data.data.lead_note);
            setLogData(response.data.data.lead_activity?.reverse());
        } catch (err) {
            console.log(err);
        }
    };

    const addFollowup = async (e) => {
        e.preventDefault();

        // 🔥 Confirmation popup
        const resultConfirm = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this followup?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#6f42c1",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, add it!",
        });

        if (!resultConfirm.isConfirmed) return;

        startLoading();
        try {
            const result = assign?.map((obj) => obj.value).join(",");

            const formData = new FormData();
            formData.append("lead_id", lead_id);
            formData.append("user_id", localStorage.getItem("auth_id"));
            formData.append("note_id", 0);
            formData.append("assign_user", result);
            formData.append("date", notedate);
            formData.append("description", description);

            await FetchNodePostData(
                null,
                "add_followup",
                localStorage.getItem("auth_token"),
                formData,
            );

            await refreshLeadDetail(lead_id);

            stopLoading();

            // ✅ Success popup
            Swal.fire({
                icon: "success",
                title: "Added!",
                text: "Followup added successfully.",
                timer: 1500,
                showConfirmButton: false,
            });

            setFollowupSideBar(false);
            setDescription("");
            setNotedate("");
            setAssign([]);
        } catch (error) {
            console.error("API ERROR:", error?.response?.data || error);
            stopLoading();

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong while adding followup.",
            });
        }
    };

    const onSaveFilter = async (e) => {
        startLoading();
        const Assign = assign?.map((obj) => obj.value).join(",");
        const Status = status?.map((obj) => obj.value).join(",");
        const Source = source?.map((obj) => obj.value).join(",");
        const Type = type?.map((obj) => obj.value).join(",");
        const Industry = industry?.map((obj) => obj.value).join(",");
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("location", country?.value);
        formData.append("assigned", Assign);
        formData.append("status", Status);
        formData.append("source", Source);
        formData.append("lead_type", Type);
        formData.append("industry", Industry);
        try {
            const response = await axios({
                method: "post",
                url: `${configure.nodeApi}/save_lead_filter`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                swal({
                    icon: "success",
                    text: "Filters Saved Successfully",
                });
                setDiable(!disable);
                stopLoading();
            });
        } catch (err) {
            console.log(err);
            stopLoading();
        }
    };

    const onClearFilter = async (e) => {
        setLeadType("");
        startLoading();
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        try {
            const response = await axios({
                method: "post",
                url: `${configure.nodeApi}/clear_lead_filter`,
                data: formData,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                swal({
                    icon: "success",
                    text: "Filters Cleared Successfully",
                }).then(async (data) => {
                    setCurrentFilters({
                        location: "",
                        asigned: "",
                        status: "",
                        source: "",
                        lead_type: "",
                        industry: "",
                        keyword: "",
                    });
                    setCountry("");
                    setSource([]);
                    setStatus([]);
                    setAssign([]);
                    setType([]);
                    setIndustry([]);
                    await fetch(1, 50, "", {
                        location: "",
                        asigned: "",
                        status: "",
                        source: "",
                        lead_type: "",
                        industry: "",
                        keyword: "",
                    });
                    console.log("callingFetch");
                    setDiable(!disable);
                });
                stopLoading();
            });
        } catch (err) {
            console.log(err);
            stopLoading();
        }
    };

    const timeDifference = new Date() - new Date(created_at);
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    const onAddPermission = () => {
        if (permissions.india[3] == 1 || permissions.uk[3] == 1) {
            navigate(`${configure.appUrl}sales/add-lead`);
        } else {
            setAccessDenied(true);
        }
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [country, source, status, assign, type, industry]);

    const handleSearch = (value) => {
        fetch(1, 50, value, currentFilters);
    };

    const debouncedSearch = React.useMemo(() => debounce(handleSearch, 600), []);

    const [taskName, setTaskName] = useState("");
    const [priority, setPriority] = useState([]);
    const [assignee, setAssignee] = useState([]);
    const [alldependency, setAllDependency] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [addTaskModal, setAddTaskModal] = useState(false);

    const fetchAllData = async () => {
        const authToken = secureLocalStorage.getItem("auth_token");
        // const datas = await fetchData(toggleLoading, "generalData", authToken)
        const datas = await axios({
            method: "get",
            url: `${configure.nodeApi}/generalData`,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${authToken}`,
            },
        });
        console.log("datas: ", datas?.data?.data);
        setAllDependency(transformGeneralData(datas?.data?.data));
        setTasks(
            datas?.data?.data?.subtasks?.map((obj) => ({
                id: obj.task,
                related: obj.related,
                subtasks: obj.subtasks,
                value: obj.task,
                label: obj.task,
            })),
        );
    };

    function debounce(func, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => func(...args), delay);
        };
    }

    const countsData = useMemo(() => {
        return [
            {
                title: "Extreme Hot",
                count: extremeHotCount,
            },
            {
                title: "Hot",
                count: hotCount,
            },
            {
                title: "Warm",
                count: warmCount,
            },
            {
                title: "Cold",
                count: coldCount,
            },
            {
                title: "Normal",
                count: normalCount,
            },
        ];
    }, [extremeHotCount, hotCount, warmCount, coldCount, normalCount]);

    function filterByType(lead_type) {
        if (!leadType || leadType !== lead_type) {
            setLeadType(lead_type);
            onFilter(null, lead_type);
            //   fetch(1, limit, "", { lead_type });
            // await fetch(1, limit, "", newFilters); // Reset to page 1
        } else {
            setLeadType("");
            onFilter(null);
        }
    }

    // lead_data comes back from all_lead_data as an array (one row) — every
    // read here must go through [0], not the array itself.
    const leadInfo = lead_data?.[0] || {};
    const primaryContact = (() => {
        try {
            const parsed =
                typeof leadInfo.person_details === "string"
                    ? JSON.parse(leadInfo.person_details)
                    : leadInfo.person_details;
            return Array.isArray(parsed) ? parsed[0] || null : null;
        } catch {
            return null;
        }
    })();

    // Lead -> RFP -> Proposal -> Contract -> Customer tracker (View Lead modal)
    const ctpStatus = Number(leadInfo?.ctp_status) || 0;
    let furthestStage = 0;
    if (stageTracker.rfp) furthestStage = 1;
    if (stageTracker.proposal) furthestStage = 2;
    if (stageTracker.contract) furthestStage = 3;
    if (ctpStatus >= 4) furthestStage = 4;
    const stageStatusAt = (idx) =>
        idx < furthestStage ? "done" : idx === furthestStage ? "active" : "pending";
    const trackerStages = [
        {
            key: "lead",
            label: "Lead",
            status: stageStatusAt(0),
            date: leadInfo?.created_at || created_at,
        },
        {
            key: "rfp",
            label: "RFP",
            status: stageStatusAt(1),
            selected: activeStageView === "rfp",
            onClick: stageTracker.rfp ? () => setActiveStageView("rfp") : undefined,
            date: stageTracker.rfp?.created_at,
        },
        {
            key: "proposal",
            label: "Proposal",
            status: stageStatusAt(2),
            link: stageTracker.proposal
                ? `${configure.appUrl}sales/edit-proposal/${stageTracker.proposal.id}`
                : undefined,
            date: stageTracker.proposal?.created_at,
        },
        {
            key: "contract",
            label: "Contract",
            status: stageStatusAt(3),
            link: stageTracker.contract
                ? `${configure.appUrl}sales/view-contract/${stageTracker.contract.id}`
                : undefined,
            date: stageTracker.contract?.startdate || stageTracker.contract?.created_at,
        },
        {
            key: "customer",
            label: "Customer",
            status: stageStatusAt(4),
            date: ctpStatus >= 4 ? leadInfo?.updated_at : undefined,
        },
    ];
    const activeStageKey = trackerStages.find((s) => s.status === "active")?.key;

    // Compact per-row tracker for the table's second row (uses the current_stage/days_in_stage
    // already returned by /api/all_lead — no extra fetch per row).
    const STAGE_KEYS = ["lead", "rfp", "proposal", "contract", "customer"];
    const STAGE_LABELS = { lead: "New", rfp: "RFP", proposal: "Proposal", contract: "Contract", customer: "Customer" };
    // contract.approve == 1: signed/Won. contract.cancelled == 1: Lost.
    // Either one is a final outcome, independent of current_stage/ctp_status
    // (a lead can be Won via contract approval before ctp_status formally
    // flags it as "customer") -- so once decided, every dot up through
    // Customer is forced to "done" rather than following currentIdx.
    const getLeadOutcome = (original) => {
        if (original?.contract_approve == 1) return "won";
        if (original?.contract_cancelled == 1) return "lost";
        return null;
    };
    const getRowStages = (original) => {
        const currentIdx = Math.max(0, STAGE_KEYS.indexOf(original?.current_stage || "lead"));
        const outcome = getLeadOutcome(original);
        return STAGE_KEYS.map((key, idx) => ({
            key,
            label:
                key === "customer" && outcome
                    ? outcome === "won" ? "Won" : "Lost"
                    : STAGE_LABELS[key],
            status:
                outcome === "lost"
                    ? "lost"
                    : outcome === "won"
                    ? "done"
                    : idx < currentIdx
                    ? "done"
                    : idx === currentIdx
                    ? "active"
                    : "pending",
            days: idx === currentIdx ? Number(original?.days_in_stage) : undefined,
        }));
    };

    return (
        <React.Fragment>
            {/* {isLoading && <Loader />} */}
            {loadingCounter > 0 && <Loader />}
            <div className="page-content" id="lead-listing">
                <Container fluid>
                    <Breadcrumbs
                        title="Dashboard"
                        breadcrumbItem="Lead"
                        englishVideo="https://zithastechnologiespvtltd695-my.sharepoint.com/:v:/g/personal/earthdesk_zithas_com/EWWbgyc5YpVGp-3zgYtrmswB28AYPFDqnt1mbQpcUxURKg?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&e=VTLlRp&download=1"
                        hindiVideo="https://zithastechnologiespvtltd695-my.sharepoint.com/:v:/g/personal/earthdesk_zithas_com/EWWbgyc5YpVGp-3zgYtrmswB28AYPFDqnt1mbQpcUxURKg?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D&e=VTLlRp&download=1"
                    />

                    <Row>
                        <Col lg={12} className="p-0">
                            <Card>
                                <CardBody>
                                    <div className="responsive-table">
                                        <div>
                                            <div
                                                className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                                                    }`}
                                            >
                                                <a
                                                    onClick={() => onAddPermission()}
                                                    className="btn btn-purple  fix-btn btn-label pe-0"
                                                >
                                                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                                                    <span>Lead</span>
                                                </a>
                                                <button
                                                    onClick={() => navigate(-1)}
                                                    className="btn btn-red  fix-btn btn-label pe-0"
                                                >
                                                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                                    <span>Cancel</span>
                                                </button>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 lead-toolbar-row">
                                                <div className="d-flex align-items-center">
                                                    <select
                                                        className="form-select"
                                                        style={{ width: "100px" }}
                                                        value={limit}
                                                        onChange={(e) => {
                                                            setLimit(Number(e.target.value));
                                                            fetch(1, Number(e.target.value)); // reset to first page
                                                        }}
                                                    >
                                                        {[10, 25, 50, 100].map((size) => (
                                                            <option key={size} value={size}>
                                                                Show {size}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="d-flex justify-content-end align-items-center flex-wrap gap-2">
                                                    <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                                                        <div className="position-relative">
                                                            <label
                                                                htmlFor="search-bar-0"
                                                                className="search-label"
                                                            >
                                                                <span
                                                                    id="search-bar-0-label"
                                                                    className="sr-only"
                                                                >
                                                                    Search this table
                                                                </span>
                                                                <input
                                                                    onChange={(e) => {
                                                                        debouncedSearch(e.target.value);
                                                                    }}
                                                                    id="search-bar-0"
                                                                    type="text"
                                                                    className="form-control rounded h-100"
                                                                    placeholder={
                                                                        fullLeadLoading
                                                                            ? "Loading search engine..."
                                                                            : "Search..."
                                                                    }
                                                                />
                                                            </label>
                                                            <i className="bx bx-search-alt search-icon"></i>
                                                        </div>
                                                    </div>
                                                    <button
                                                        onClick={() => setFormPopup(!formPopup)}
                                                        className="btn btn-outline-secondary"
                                                    >
                                                        <i className="fas fa-filter"></i>
                                                    </button>
                                                    <a
                                                        id="add"
                                                        onClick={() => onAddPermission()}
                                                        className="btn text-white btn-save btn-label"
                                                    >
                                                        <i className="fas fa-plus me-2 icon-size label-icon"></i>
                                                        Lead
                                                    </a>
                                                    <button
                                                        onClick={() => navigate(-1)}
                                                        className="btn btn-red btn-label"
                                                    >
                                                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                                        CANCEL
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center fs-5 gap-3 flex-wrap mb-2 lead-filter-row">
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    {countsData.map((tab) => (
                                                        <a
                                                            key={tab.title}
                                                            className={`d-flex gap-2 align-items-center general-box ${leadType === tab.title && "bg-purple"
                                                                }`}
                                                            onClick={() => filterByType(tab.title)}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={leadType === tab.title}
                                                                style={{ accentColor: "white" }}
                                                            />
                                                            <h5 className="text-purple mb-0">
                                                                {tab.title} :{" "}
                                                            </h5>
                                                            <h5 className="text-primary mb-0">
                                                                {tab.count}
                                                            </h5>
                                                        </a>
                                                    ))}
                                                    <a className="d-flex gap-3 align-items-center general-box bg-light-red">
                                                        <h5 className="text-danger mb-0">Proposal : </h5>
                                                        <h5 className="text-danger mb-0">
                                                            {
                                                                data?.filter(
                                                                    (obj) =>
                                                                        obj?.sname?.toLowerCase() == "proposal" &&
                                                                        obj?.lead_type != "Cold",
                                                                )?.length
                                                            }
                                                        </h5>
                                                    </a>
                                                </div>
                                                <div className="d-flex align-items-center gap-3 lead-table-legend text-muted">
                                                    <span>
                                                        <i className="fas fa-file-alt me-1"></i>
                                                        Notes
                                                    </span>
                                                    <span>
                                                        <i className="fas fa-bell me-1"></i>
                                                        Follow-ups
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="position-relative">
                                                <Table
                                                    className="table table-bordered mt-4"
                                                    {...getTableProps()}
                                                >
                                                    <colgroup className="fix-lead-header">
                                                        {headerGroups[0]?.headers.map((column, index) => (
                                                            <col key={index} className={`t-col-${index + 1}`} />
                                                        ))}
                                                    </colgroup>
                                                    <thead
                                                        className={`${fixedContent ? "fix-header" : ""
                                                            } fix-lead-header`}
                                                    >
                                                        {headerGroups.map((headerGroup, i) => (
                                                            <tr
                                                                key={i}
                                                                {...headerGroup.getHeaderGroupProps()}
                                                            >
                                                                {headerGroup.headers.map((column, index) => (
                                                                    <th
                                                                        key={index}
                                                                        className={`t-col-${index + 1} ${column.className || ""
                                                                            }`}
                                                                        {...column.getHeaderProps()}
                                                                    >
                                                                        {column.render("Header")}
                                                                        {column.isInfoIcon ? (
                                                                            <a
                                                                                onClick={() => {
                                                                                    setNameModal(true);
                                                                                    setTitle(column.Header);
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    title="info"
                                                                                    className={`bx bx-info-circle ms-1 info-icon assign-${index}`}
                                                                                ></i>
                                                                            </a>
                                                                        ) : null}
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </thead>

                                                    <tbody
                                                        className="fix-lead-header"
                                                        {...getTableBodyProps()}
                                                    >
                                                        {page.map((row, i) => {
                                                            prepareRow(row);
                                                            let backColor;
                                                            const outcome = getLeadOutcome(row.original);
                                                            if (outcome === "won") {
                                                                backColor = "lead-row-won";
                                                            } else if (outcome === "lost") {
                                                                backColor = "lead-row-lost";
                                                            } else if (row.original.lead_type == "Hot") {
                                                                backColor = "bd-hot";
                                                            }
                                                            return (
                                                                <tr
                                                                    className={`row-hover lead-row ${backColor}`}
                                                                    {...row.getRowProps()}
                                                                    key={i}
                                                                >
                                                                    {row.cells.map((cell, index) => {
                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`t-col-${index + 1} ${cell.column.className || ""
                                                                                    }`}
                                                                                onClick={() =>
                                                                                    cell.column.Header === "Company"
                                                                                        ? navigate(
                                                                                            `${configure.appUrl}sales/edit-lead/${cell.row.original.id}`,
                                                                                        )
                                                                                        : undefined
                                                                                }
                                                                                {...cell.getCellProps()}
                                                                            >
                                                                                {cell.render("Cell")}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            );
                                                        })}
                                                        {page.length == 0 ? (
                                                            <tr>
                                                                <td className="text-center" colSpan={columns.length}>
                                                                    No Leads Available
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                    </tbody>
                                                </Table>

                                                {formPopup ? (
                                                    <div className="popup-form p-4">
                                                        <Form onSubmit={onFilter}>
                                                            <Row className="align-items-end">
                                                                <Row
                                                                    className="d-flex pe-0 me-0"
                                                                    style={{ width: "100%" }}
                                                                >
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Location</label>
                                                                        <Select
                                                                            placeholder="Select Location"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            onChange={(e) => setCountry(e)}
                                                                            value={country}
                                                                            styles={colourStyles}
                                                                            options={location}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Source</label>
                                                                        {country.value == "2" ? (
                                                                            <Select
                                                                                placeholder="Select Source"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={sourceuk_option}
                                                                                value={source}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setSource(e)}
                                                                            />
                                                                        ) : country.value == "1" ? (
                                                                            <Select
                                                                                placeholder="Select Source"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={sourceIn_option}
                                                                                value={source}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setSource(e)}
                                                                            />
                                                                        ) : (
                                                                            <Select
                                                                                placeholder="Select Source"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={allsource_option}
                                                                                value={source}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setSource(e)}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Status</label>
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            styles={colourStyles}
                                                                            options={status_option}
                                                                            value={status}
                                                                            closeMenuOnSelect={false}
                                                                            isMulti
                                                                            onChange={(e) => setStatus(e)}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mb-2">
                                                                        <label htmlFor="">Assigned</label>
                                                                        {country.value == "2" ? (
                                                                            <Select
                                                                                placeholder="Select Assigned"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={useruk_option}
                                                                                value={assign}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setAssign(e)}
                                                                            />
                                                                        ) : country.value == "1" ? (
                                                                            <Select
                                                                                placeholder="Select Assigned"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={userIn_option}
                                                                                value={assign}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setAssign(e)}
                                                                            />
                                                                        ) : (
                                                                            <Select
                                                                                placeholder="Select Assigned"
                                                                                className="basic-multi-select"
                                                                                classNamePrefix=" select"
                                                                                styles={colourStyles}
                                                                                options={alluser_option}
                                                                                value={assign}
                                                                                closeMenuOnSelect={false}
                                                                                isMulti
                                                                                onChange={(e) => setAssign(e)}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                    <div className="col-md-3 mt-2">
                                                                        <label htmlFor="">Lead Type</label>
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            styles={colourStyles}
                                                                            options={type_option}
                                                                            closeMenuOnSelect={false}
                                                                            value={type}
                                                                            onChange={(e) => setType(e)}
                                                                            isMulti
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mt-2">
                                                                        <label htmlFor="">Industry</label>
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            className="basic-multi-select"
                                                                            classNamePrefix=" select"
                                                                            styles={colourStyles}
                                                                            options={industry_option}
                                                                            closeMenuOnSelect={false}
                                                                            value={industry}
                                                                            onChange={(e) => setIndustry(e)}
                                                                            isMulti
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 mt-2">
                                                                        <label htmlFor="">
                                                                            Save and Clear Filters
                                                                        </label>
                                                                        <div>
                                                                            <a
                                                                                className="btn  btn-primary mr-10"
                                                                                onClick={onSaveFilter}
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    backgroundColor: "#93a6ff",
                                                                                    borderColor: "#93a6ff",
                                                                                    color: "black",
                                                                                }}
                                                                            >
                                                                                Save Filters
                                                                            </a>
                                                                            <a
                                                                                className="btn  btn-danger"
                                                                                onClick={onClearFilter}
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    backgroundColor: "#fed36d",
                                                                                    borderColor: "#fed36d",
                                                                                    color: "black",
                                                                                }}
                                                                            >
                                                                                Clear Filters
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex col-md-3 align-items-end justify-content-end">
                                                                        <div className="mr-10">
                                                                            <button className="btn  btn-purple">
                                                                                <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                                                                                Filter
                                                                            </button>
                                                                        </div>
                                                                        <div className="">
                                                                            <a
                                                                                className="btn  btn-red"
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    setDatas(displayData);
                                                                                    setFormPopup(!formPopup);
                                                                                }}
                                                                            >
                                                                                <i className="dripicons-cross me-1 icon-center"></i>{" "}
                                                                                Close
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </Row>
                                                            </Row>
                                                        </Form>
                                                        <i className="bi bi-triangle-fill pop-icon"></i>
                                                    </div>
                                                ) : null}
                                            </div>
                                            <Row className="justify-content-md-end justify-content-center align-items-center">
                                                <ServerPagination
                                                    currentPage={currentPage}
                                                    pageSize={limit}
                                                    totalItems={total}
                                                    onPageChange={async (newPage) => {
                                                        startLoading(); // optional but recommended
                                                        await fetch(newPage, limit, "", currentFilters);
                                                        stopLoading();
                                                    }}
                                                />
                                            </Row>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* View Modal */}
            <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
                <div className="modal-header mb-0 lead-modal-banner">
                    <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ width: "100%" }}
                    >
                        <div className="d-flex align-items-center">
                            <div className="lead-modal-avatar">
                                {getInitials(leadInfo?.company || "Lead")}
                            </div>
                            <div className="ms-3">
                                <h5 className="modal-title mt-0 mb-1 d-flex align-items-center">
                                    {formatLeadValue(leadInfo?.company, "Lead Details")}
                                    <Badge
                                        pill
                                        className="badge-soft-primary ms-2 lead-modal-status-badge"
                                    >
                                        {formatLeadValue(leadInfo?.status_name, "New")}
                                    </Badge>
                                </h5>
                                <div className="lead-modal-subline">
                                    <span>Lead ID: {viewId}</span>
                                    {leadInfo?.email && (
                                        <span>
                                            <i className="bx bx-envelope"></i> {leadInfo.email}
                                        </span>
                                    )}
                                    {leadInfo?.phonenumber && (
                                        <span>
                                            <i className="bx bx-phone"></i> {leadInfo.phonenumber}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="text-end me-4">
                                <div className="lead-modal-meta-label">Created On</div>
                                <div className="lead-modal-meta-value">
                                    {moment(created_at).format("DD MMM YYYY")} (
                                    {parseFloat(daysDifference).toFixed(0)}d)
                                </div>
                            </div>
                            <div className="lead-modal-person-block me-4">
                                <div className="lead-modal-person-avatar">
                                    {leadInfo?.avatar ? (
                                        <img
                                            src={`${configure.imgUrl}${leadInfo.avatar}`}
                                            alt=""
                                        />
                                    ) : (
                                        <span>{getInitials(leadInfo?.asigned || "NA")}</span>
                                    )}
                                </div>
                                <div className="text-end">
                                    <div className="lead-modal-meta-label">Assigned</div>
                                    <div className="lead-modal-meta-value">
                                        {formatLeadValue(leadInfo?.asigned)}
                                    </div>
                                </div>
                            </div>
                            <div className="lead-modal-person-block">
                                <div className="lead-modal-person-avatar">
                                    {leadInfo?.caller_avatar ? (
                                        <img
                                            src={`${configure.imgUrl}${leadInfo.caller_avatar}`}
                                            alt=""
                                        />
                                    ) : (
                                        <i className="bx bx-user-circle" style={{ fontSize: "22px" }}></i>
                                    )}
                                </div>
                                <div className="text-end">
                                    <div className="lead-modal-meta-label">Lead Communicator</div>
                                    <div className="lead-modal-meta-value">
                                        {formatLeadValue(leadInfo?.caller_name)}
                                    </div>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={() => {
                                    setmodal_fullscreen(false);
                                }}
                                className="ms-4"
                                style={{ border: "none", backgroundColor: "transparent" }}
                            >
                                <span
                                    aria-hidden="true"
                                    style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}
                                >
                                    {" "}
                                    &times;{" "}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="modal-body hide-bottom-scrollbar lead-modal-scroll-body ps-3 pe-0 pt-0">
                    <Row className="gx-4 justify-content-between lead-modal-tab-row">
                        <Col md="2" className="side-tab py-3 lead-sticky-sidetab">
                            <Nav pills className="flex-column">
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "5",
                                        })}
                                        onClick={() => {
                                            toggleVertical("5");
                                        }}
                                    >
                                        Dashboard
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "1",
                                        })}
                                        onClick={() => {
                                            toggleVertical("1");
                                        }}
                                    >
                                        Profile
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "2",
                                        })}
                                        onClick={() => {
                                            toggleVertical("2");
                                        }}
                                    >
                                        Notes
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "4",
                                        })}
                                        onClick={() => {
                                            toggleVertical("4");
                                        }}
                                    >
                                        Follow Up
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "3",
                                        })}
                                        onClick={() => {
                                            toggleVertical("3");
                                        }}
                                    >
                                        Activity Log
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "6",
                                        })}
                                        onClick={() => {
                                            toggleVertical("6");
                                        }}
                                    >
                                        Proposals
                                    </NavLink>
                                </NavItem>

                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "7",
                                        })}
                                        onClick={() => {
                                            toggleVertical("7");
                                        }}
                                    >
                                        Contracts
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col md="10" className="lead-modal-content-col">
                            <div className="px-4 h-100 pl-0">
                                <TabContent
                                    activeTab={verticalActiveTab}
                                    className="text-muted mt-4 mt-md-0"
                                >
                                    <TabPane tabId="5">
                                        <div className="lead-pipeline-dashboard">
                                            <StageTracker stages={trackerStages} />

                                            {activeStageView === "rfp" && stageTracker.rfp && (
                                                <div className="rfp-inline-summary mt-3 p-3">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <h6 className="mb-0 text-purple">RFP Details</h6>
                                                        <div className="d-flex align-items-center gap-3">
                                                            <a
                                                                href={`${configure.appUrl}request-for-proposal/${viewId}`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                Open Full RFP <i className="bx bx-link-external"></i>
                                                            </a>
                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                style={{ fontSize: "11px" }}
                                                                onClick={() => setActiveStageView(null)}
                                                            ></button>
                                                        </div>
                                                    </div>
                                                    <Row>
                                                        <Col md="3">
                                                            <div className="text-muted lead-meta-line">Status</div>
                                                            <div>{formatLeadValue(stageTracker.rfp.status)}</div>
                                                        </Col>
                                                        <Col md="3">
                                                            <div className="text-muted lead-meta-line">Grand Total</div>
                                                            <div>
                                                                {stageTracker.rfp.grand_total
                                                                    ? `${stageTracker.rfp.currency_symbol || ""} ${stageTracker.rfp.grand_total}`
                                                                    : "-"}
                                                            </div>
                                                        </Col>
                                                        <Col md="3">
                                                            <div className="text-muted lead-meta-line">Created</div>
                                                            <div>{formatDate(stageTracker.rfp.created_at)}</div>
                                                        </Col>
                                                        <Col md="3">
                                                            <div className="text-muted lead-meta-line">Last Updated</div>
                                                            <div>{formatDate(stageTracker.rfp.updated_at)}</div>
                                                        </Col>
                                                    </Row>
                                                    {parseStepStatus(stageTracker.rfp.step_status) && (
                                                        <div className="mt-2 d-flex gap-3 flex-wrap">
                                                            {Object.entries(parseStepStatus(stageTracker.rfp.step_status)).map(
                                                                ([step, status]) => (
                                                                    <div key={step} className="lead-meta-line">
                                                                        <span className="text-muted text-capitalize">{step}</span>:{" "}
                                                                        <span className="fw-semibold text-capitalize">{status}</span>
                                                                    </div>
                                                                ),
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            <div className="dashboard-kpi-row">
                                                <div className="kpi-tile">
                                                    <div className="kpi-tile-icon">
                                                        <i className="bx bxs-flag-checkered"></i>
                                                    </div>
                                                    <div className="kpi-tile-body">
                                                        <div className="kpi-tile-value">
                                                            {trackerStages.find((s) => s.status === "active")?.label ||
                                                                "Lead"}
                                                        </div>
                                                        <div className="kpi-tile-label">Current Stage</div>
                                                    </div>
                                                </div>
                                                <div className="kpi-tile">
                                                    <div className="kpi-tile-icon is-info">
                                                        <i className="bx bx-time-five"></i>
                                                    </div>
                                                    <div className="kpi-tile-body">
                                                        <div className="kpi-tile-value">
                                                            {parseFloat(daysDifference).toFixed(0)} days
                                                        </div>
                                                        <div className="kpi-tile-label">In Pipeline</div>
                                                    </div>
                                                </div>
                                                <div className="kpi-tile">
                                                    <div className="kpi-tile-icon is-warning">
                                                        <i className="bx bx-file"></i>
                                                    </div>
                                                    <div className="kpi-tile-body">
                                                        <div className="kpi-tile-value">
                                                            {stageTracker.rfp?.grand_total
                                                                ? `${stageTracker.rfp.currency_symbol || ""} ${stageTracker.rfp.grand_total}`
                                                                : "Not raised"}
                                                        </div>
                                                        <div className="kpi-tile-label">RFP Value</div>
                                                    </div>
                                                </div>
                                                <div className="kpi-tile">
                                                    <div
                                                        className={classnames("kpi-tile-icon", {
                                                            "is-success": Boolean(stageTracker.contract),
                                                        })}
                                                    >
                                                        <i className="bx bxs-badge-check"></i>
                                                    </div>
                                                    <div className="kpi-tile-body">
                                                        <div className="kpi-tile-value">
                                                            {stageTracker.contract?.value
                                                                ? formatLeadValue(stageTracker.contract.value)
                                                                : "Not signed"}
                                                        </div>
                                                        <div className="kpi-tile-label">Contract Value</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                className={classnames("pipeline-card mb-3", {
                                                    "is-active-stage": activeStageKey === "lead",
                                                })}
                                            >
                                                <div className="pipeline-card-header">
                                                    <i className="bx bx-user-circle"></i>
                                                    <h6 className="mb-0">Lead</h6>
                                                </div>
                                                <Row>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Company</div>
                                                        <div>{formatLeadValue(leadInfo.company, "Unnamed Company")}</div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Industry</div>
                                                        <div>{formatLeadValue(leadInfo.industry_name)}</div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Source</div>
                                                        <div>{formatLeadValue(leadInfo.source)}</div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Assigned</div>
                                                        <div>{formatLeadValue(leadInfo.asigned)}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Status</div>
                                                        <div>{formatLeadValue(leadInfo.status_name)}</div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Lead Type</div>
                                                        <div>{formatLeadValue(leadInfo.lead_type)}</div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Email</div>
                                                        <div>{formatLeadValue(leadInfo.email)}</div>
                                                    </Col>
                                                    <Col md="3">
                                                        <div className="text-muted lead-meta-line">Phone</div>
                                                        <div>{formatLeadValue(leadInfo.phonenumber)}</div>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3">
                                                    <Col md="6">
                                                        <div className="text-muted lead-meta-line">Location</div>
                                                        <div>
                                                            {formatLeadValue(
                                                                [leadInfo.city_name, leadInfo.state_name, leadInfo.country_name]
                                                                    .filter(Boolean)
                                                                    .join(", "),
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="text-muted lead-meta-line mb-1">Primary Contact</div>
                                                        {primaryContact ? (
                                                            <div className="contact-chip">
                                                                <div className="contact-chip-body">
                                                                    <div className="contact-chip-name">
                                                                        {formatLeadValue(primaryContact.person_name)}
                                                                        {primaryContact.person_designation && (
                                                                            <span className="contact-chip-designation">
                                                                                {" "}
                                                                                ({primaryContact.person_designation})
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="contact-chip-links">
                                                                        {primaryContact.person_email && (
                                                                            <a href={`mailto:${primaryContact.person_email}`}>
                                                                                <i className="bx bx-envelope"></i>
                                                                                {primaryContact.person_email}
                                                                            </a>
                                                                        )}
                                                                        {primaryContact.person_phone && (
                                                                            <a href={`tel:${primaryContact.person_phone}`}>
                                                                                <i className="bx bx-phone"></i>
                                                                                {primaryContact.person_phone}
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div>-</div>
                                                        )}
                                                    </Col>
                                                </Row>
                                                {leadInfo.description && (
                                                    <Row className="mt-3">
                                                        <Col md="12">
                                                            <div className="text-muted lead-meta-line">Description</div>
                                                            <div
                                                                className="lead-desc-preview"
                                                                dangerouslySetInnerHTML={{ __html: leadInfo.description }}
                                                            ></div>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </div>

                                            <Row className="g-3 mb-3">
                                                <Col md="4">
                                                    <div
                                                        className={classnames("pipeline-card h-100", {
                                                            "is-pending": !stageTracker.rfp,
                                                            "is-active-stage": activeStageKey === "rfp",
                                                        })}
                                                    >
                                                        <div className="pipeline-card-header">
                                                            <i className="bx bx-file"></i>
                                                            <h6 className="mb-0">RFP</h6>
                                                            {stageTracker.rfp && (
                                                                <span className="badge badge-soft-primary pipeline-card-status ms-2">
                                                                    {formatLeadValue(stageTracker.rfp.status)}
                                                                </span>
                                                            )}
                                                        </div>
                                                        {stageTracker.rfp ? (
                                                            <>
                                                                <div className="pipeline-card-detail-list">
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Service</span>
                                                                        <span>
                                                                            {formatLeadValue(
                                                                                stageTracker.rfp.services?.[0]?.title ||
                                                                                stageTracker.rfp.services?.[0]?.label,
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Total Hours</span>
                                                                        <span>
                                                                            {stageTracker.rfp.roles_breakdown?.total_hours
                                                                                ? `${stageTracker.rfp.roles_breakdown.total_hours} hrs`
                                                                                : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Rate / Hr</span>
                                                                        <span>
                                                                            {stageTracker.rfp.final_rate_per_hr
                                                                                ? `${stageTracker.rfp.currency_symbol || ""} ${stageTracker.rfp.final_rate_per_hr}`
                                                                                : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Grand Total</span>
                                                                        <span>
                                                                            {stageTracker.rfp.grand_total
                                                                                ? `${stageTracker.rfp.currency_symbol || ""} ${stageTracker.rfp.grand_total}`
                                                                                : "-"}
                                                                        </span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Created</span>
                                                                        <span>{formatDate(stageTracker.rfp.created_at)}</span>
                                                                    </div>
                                                                </div>
                                                                <a
                                                                    href={`${configure.appUrl}request-for-proposal/${viewId}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="pipeline-card-open-link"
                                                                >
                                                                    Open RFP <i className="bx bx-link-external"></i>
                                                                </a>
                                                            </>
                                                        ) : (
                                                            <div className="pipeline-card-empty">
                                                                <i className="bx bx-file-blank"></i>
                                                                This lead hasn't reached the RFP stage yet.
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col md="4">
                                                    <div
                                                        className={classnames("pipeline-card h-100", {
                                                            "is-pending": !stageTracker.proposal,
                                                            "is-active-stage": activeStageKey === "proposal",
                                                        })}
                                                    >
                                                        <div className="pipeline-card-header">
                                                            <i className="bx bx-file-find"></i>
                                                            <h6 className="mb-0">Proposal</h6>
                                                            {stageTracker.proposal && (
                                                                <span
                                                                    className={`badge ${stageTracker.proposal.status_color || "badge-soft-primary"
                                                                        } pipeline-card-status ms-2`}
                                                                >
                                                                    {formatLeadValue(stageTracker.proposal.status_name)}
                                                                </span>
                                                            )}
                                                        </div>
                                                        {stageTracker.proposal ? (
                                                            <>
                                                                <div className="pipeline-card-detail-list">
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Company</span>
                                                                        <span>{formatLeadValue(stageTracker.proposal.companyname)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Contact</span>
                                                                        <span>{formatLeadValue(stageTracker.proposal.contactname)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Type</span>
                                                                        <span>{formatLeadValue(stageTracker.proposal.type)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Date</span>
                                                                        <span>{formatDate(stageTracker.proposal.date)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Open Till</span>
                                                                        <span>{formatDate(stageTracker.proposal.opentill)}</span>
                                                                    </div>
                                                                </div>
                                                                <a
                                                                    href={`${configure.appUrl}sales/edit-proposal/${stageTracker.proposal.id}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="pipeline-card-open-link"
                                                                >
                                                                    Open Proposal <i className="bx bx-link-external"></i>
                                                                </a>
                                                            </>
                                                        ) : (
                                                            <div className="pipeline-card-empty">
                                                                <i className="bx bx-file-blank"></i>
                                                                This lead hasn't reached the Proposal stage yet.
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>

                                                <Col md="4">
                                                    <div
                                                        className={classnames("pipeline-card h-100", {
                                                            "is-pending": !stageTracker.contract,
                                                            "is-active-stage": activeStageKey === "contract",
                                                        })}
                                                    >
                                                        <div className="pipeline-card-header">
                                                            <i className="bx bx-edit-alt"></i>
                                                            <h6 className="mb-0">Contract</h6>
                                                            {stageTracker.contract && (
                                                                <span
                                                                    className={`badge ${stageTracker.contract.approve == 1
                                                                        ? "badge-soft-success"
                                                                        : "badge-soft-warning"
                                                                        } pipeline-card-status ms-2`}
                                                                >
                                                                    {stageTracker.contract.approve == 1 ? "Approved" : "Pending Approval"}
                                                                </span>
                                                            )}
                                                        </div>
                                                        {stageTracker.contract ? (
                                                            <>
                                                                <div className="pipeline-card-detail-list">
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Service</span>
                                                                        <span>{formatLeadValue(stageTracker.contract.service)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Contact Person</span>
                                                                        <span>{formatLeadValue(stageTracker.contract.contact_person)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Payment</span>
                                                                        <span>
                                                                            {formatLeadValue(stageTracker.contract.payment_schedule)}
                                                                            {stageTracker.contract.payment_percent
                                                                                ? ` (${stageTracker.contract.payment_percent}%)`
                                                                                : ""}
                                                                        </span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Value</span>
                                                                        <span>{formatLeadValue(stageTracker.contract.value)}</span>
                                                                    </div>
                                                                    <div className="pipeline-card-detail-row">
                                                                        <span className="text-muted lead-meta-line">Duration</span>
                                                                        <span>
                                                                            {formatDate(stageTracker.contract.startdate)} –{" "}
                                                                            {formatDate(stageTracker.contract.enddate)}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <a
                                                                    href={`${configure.appUrl}sales/view-contract/${stageTracker.contract.id}`}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    className="pipeline-card-open-link"
                                                                >
                                                                    Open Contract <i className="bx bx-link-external"></i>
                                                                </a>
                                                            </>
                                                        ) : (
                                                            <div className="pipeline-card-empty">
                                                                <i className="bx bx-file-blank"></i>
                                                                This lead hasn't reached the Contract stage yet.
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="1">
                                        <ViewProfile viewData={lead_data[0]} />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <ViewNotes
                                            notesData={note_data}
                                            view_assign={view_assign}
                                            viewId={viewId}
                                            verticalActiveTab={verticalActiveTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <ViewActivity logData={log_data} />
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <ViewFollowUp
                                            followData={follow_data}
                                            view_assign={view_assign}
                                        />
                                    </TabPane>
                                    <TabPane tabId="6">
                                        <ViewProposals
                                            leadId={viewId}
                                            verticalActiveTab={verticalActiveTab}
                                        />
                                    </TabPane>
                                    <TabPane tabId="7">
                                        <ViewContracts
                                            leadId={viewId}
                                            verticalActiveTab={verticalActiveTab}
                                        />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal
                isOpen={name_modal}
                toggle={() => {
                    tog_center();
                }}
                className="bd-info-popup"
                centered
            >
                <div className="modal-header bd-head-info">
                    <h5 className="modal-title mt-0">
                        <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
                        {title}
                    </h5>
                </div>
                <div className="modal-body pb-0">
                    <div className="d-flex">
                        <div className="col-5 pr-30">
                            <div>
                                <img src={InfoGif} className="w-100" />
                            </div>
                        </div>
                        <div className="mt-20 ">
                            <div>
                                {info.map((item) => {
                                    if (item.title == title) {
                                        return (
                                            <>
                                                <span>
                                                    <span
                                                        dangerouslySetInnerHTML={{ __html: item.mean }}
                                                    ></span>
                                                </span>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: item.purpose }}
                                                ></div>
                                            </>
                                        );
                                    }
                                })}
                                <div className="text-center mt-70">
                                    <button
                                        type="button"
                                        className="btn btn-success "
                                        onClick={() => setNameModal(false)}
                                    >
                                        I Understood
                                        <i className="dripicons-thumbs-up pl-10"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <AccessDeniedPopup
                modal_Access={modal_Access}
                setAccessDenied={setAccessDenied}
            />

            {/* <div
        className={`note-sticky-form ${notesSidebar ? "d-block" : "d-none"}`}
      > */}
            {/* <Draggable handle=".head-move" cancel=".modal-body">
          <ResizableBox
            width={boxWidth}
            height={isNote ? boxHeight + 100 : boxHeight} // <-- FIXED
            style={{
              position: "fixed",
              top: "4%",
              left: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          > */}

            {/* //create task modal */}
            <Modal
                size="xl"
                isOpen={addTaskModal}
                toggle={() => setAddTaskModal(false)}
                className="modal-fullscreen"
            >
                <AddTasks
                    alldependency={alldependency}
                    tasks={tasks}
                    onCloseAddModal={() => setAddTaskModal(false)}
                    onChangeDrag={() => { }}
                    toggleLoading={(loading) =>
                        loading ? startLoading() : stopLoading()
                    }
                    updateData={() => { }}
                    tabType={0}
                    isLoading={isLoading}
                    presetTabValue="sales"
                    presetRelatedValue="lead"
                    presetRelatedId={lead_id}
                />
            </Modal>

            {/* On Hold: pick a target month/year (or Forever) to move a lead to Cold + hold tracking */}
            <Modal
                isOpen={Boolean(holdModalLead)}
                toggle={closeHoldModal}
                centered
            >
                <div className="modal-header">
                    <h5 className="modal-title">Move Lead to On Hold</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={closeHoldModal}
                    ></button>
                </div>
                <ModalBody>
                    <p className="text-muted">
                        {holdModalLead?.company} will move to Cold and be restored automatically
                        on the 1st of the selected month, unless held forever.
                    </p>

                    <div className="mb-3">
                        <label
                            style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
                            onClick={() => setHoldForever((prev) => !prev)}
                        >
                            <input
                                type="checkbox"
                                checked={holdForever}
                                onChange={(e) => setHoldForever(e.target.checked)}
                                style={{ width: "16px", height: "16px", cursor: "pointer" }}
                            />
                            Hold Forever (won't auto-restore)
                        </label>
                    </div>

                    {!holdForever && (
                        <Row>
                            <Col md={6} className="mb-2">
                                <Label>Month</Label>
                                <select
                                    className="form-select"
                                    value={holdMonth?.value || ""}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        setHoldMonth(HOLD_MONTH_OPTIONS.find((m) => m.value === val) || null);
                                    }}
                                >
                                    <option value="">Select Month</option>
                                    {HOLD_MONTH_OPTIONS.map((m) => (
                                        <option key={m.value} value={m.value}>
                                            {m.label}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label>Year</Label>
                                <select
                                    className="form-select"
                                    value={holdYear?.value || ""}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        setHoldYear(HOLD_YEAR_OPTIONS.find((y) => y.value === val) || null);
                                    }}
                                >
                                    <option value="">Select Year</option>
                                    {HOLD_YEAR_OPTIONS.map((y) => (
                                        <option key={y.value} value={y.value}>
                                            {y.label}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                        </Row>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-3">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={closeHoldModal}
                            disabled={holdSaving}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleConfirmHold}
                            disabled={holdSaving}
                        >
                            {holdSaving ? "Saving..." : "Move to On Hold"}
                        </button>
                    </div>
                </ModalBody>
            </Modal>

            {/* //notes model */}
            <Modal
                size="xl"
                isOpen={notesSidebar}
                toggle={() => {
                    notesSidebar();
                }}
                className="modal-fullscreen"
            >
                <div className="px-3">
                    {/* Row 1 — Title + Close Button */}
                    <div className=" modal-header d-flex justify-content-between align-items-center">
                        <h5 className="mt-0 head-move">Add Note</h5>

                        <div className="company-info me-0 d-flex justify-content-center align-items-center">
                            <div className="d-flex justify-content-start align-items-center py-2 pt-3 gap-4">
                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-buildings-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.company}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-person-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.personName}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-telephone-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.phonenumber}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-envelope-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.email}
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => {
                                setNotesSidebar(false);
                                onFilter(null, leadType);
                                // ✅ Fix 2: reset form state on close
                                setCkedata("");
                                setAmount("");
                                setNotedate(curentDateTime);
                                setCurrency({ label: null, value: null });
                                setselectedFiles1([]);
                                setIsNote(false);
                                setTaskName("");
                                setPriority([]);
                                setAssignee([]);
                            }}
                            className="btn-modal-close"
                        >
                            <span aria-hidden="true" className="btn-modal-span">
                                &times;
                            </span>
                        </button>
                    </div>

                    {/* Row 2 — Company Info */}

                    {/* Row 3 — Lead Description */}
                    <Row>
                        <Col>
                            <div
                                className="bg-light rounded-3 p-3"
                                style={{
                                    maxHeight: "120px",
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <div className="fw-bold text-dark mb-2">Lead Description:</div>
                                <div
                                    className="text-muted"
                                    style={{
                                        wordBreak: "break-word",
                                        lineHeight: "1.5",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            leadDetail?.description || "No description available.",
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* BODY */}
                <div
                    className="px-3 pt-2 bg-white modal-body"
                    style={{
                        // maxHeight: boxHeight - 100, // adjust as needed
                        overflowY: "auto",
                    }}
                >
                    <div className="row">
                        {/* ================= Left Side (Notes History) ================= */}
                        <div className="col-md-6">
                            <h5 className="text-dark">Notes History</h5>

                            {/* <div
                    className="mt-4"
                    style={{
                      maxHeight: "450px",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  > */}
                            <div
                                className="mt-4"
                                style={{
                                    maxHeight: boxHeight,
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <ul className="verti-timeline list-unstyled notes-box">
                                    {allNotes?.map((note, i) => {
                                        return (
                                            <li className="event-list position-relative" key={i}>
                                                <div className="event-timeline-dot connected-dot">
                                                    {note?.addedby_avatar ? (
                                                        <img
                                                            src={`${configure.imgUrl}/${note?.addedby_avatar}`}
                                                            className="msgUserImg me-3"
                                                            alt=""
                                                        />
                                                    ) : (
                                                        <div
                                                            className="defualt-img event-timeline-dot connected-dot"
                                                            title={note?.added_by}
                                                        >
                                                            {getInitials(note?.added_by || "Z")}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="d-flex">
                                                    <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div>
                                                                <p className="text-muted cursor-pointer">
                                                                    <h6 className="d-inline me-2">
                                                                        By {note.added_by}
                                                                    </h6>

                                                                    <Tooltip
                                                                        color="#f0e8f4"
                                                                        title={
                                                                            <div className="text-purple fw-bold body-font fs-6">
                                                                                <div>
                                                                                    UK Time:{" "}
                                                                                    {convertTimeZone(
                                                                                        note.created_at,
                                                                                        "Europe/London",
                                                                                        "DD-MM-YYYY hh:mm:ss a",
                                                                                    )}
                                                                                </div>

                                                                                <div>
                                                                                    US Time :{" "}
                                                                                    {moment(note.created_at)
                                                                                        .tz("America/New_York")
                                                                                        .format("DD-MM-YYYY hh:mm:ss a")}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    >
                                                                        {moment(note.created_at).format(
                                                                            "DD-MM-YYYY hh:mm:ss",
                                                                        )}
                                                                    </Tooltip>

                                                                    <span className="pl-15">
                                                                        Got in touch with this lead at{" "}
                                                                        <Tooltip
                                                                            color="#f0e8f4"
                                                                            title={
                                                                                <div className="text-purple fw-bold body-font fs-6">
                                                                                    <div>
                                                                                        UK Time:{" "}
                                                                                        {convertTimeZone(
                                                                                            note.date,
                                                                                            "Europe/London",
                                                                                        )}
                                                                                    </div>

                                                                                    <div>
                                                                                        US Time :{" "}
                                                                                        {convertTimeZone(
                                                                                            note.date,
                                                                                            "America/New_York",
                                                                                            "DD-MM-YYYY hh:mm:ss a",
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        >
                                                                            {moment(note.date).format(
                                                                                "DD-MM-YYYY hh:mm a",
                                                                            )}
                                                                        </Tooltip>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <i className="bi bi-triangle-fill note-icon"></i>

                                                        <div
                                                            className="Features word-wrap"
                                                            dangerouslySetInnerHTML={{
                                                                __html: note.description,
                                                            }}
                                                        />

                                                        <p className="mb-2">
                                                            Amount : {note.currency_symbol} {note.amount}{" "}
                                                        </p>

                                                        {note.link != null ? (
                                                            <p className="mb-1">
                                                                Attachment :{" "}
                                                                <a
                                                                    target="_blank "
                                                                    className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                                                    rel="noreferrer"
                                                                    type="button"
                                                                    href={note.link}
                                                                >
                                                                    <i className="fas fa-eye"></i> View
                                                                </a>
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* ================= Right Side (Add Note Form) ================= */}
                        <div
                            className="col-md-6"
                            style={{
                                maxHeight: boxHeight,
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                            }}
                        >
                            <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                                <Form onSubmit={addNotes} className="w-100">
                                    <Row className="align-items-center justify-content-between">
                                        {/* Header */}
                                        <div className="col-12 d-flex justify-content-between align-items-center">
                                            {/* LEFT – Title */}
                                            <h5 className="text-dark">Add New Note</h5>

                                            {/* RIGHT – Toggle + Buttons */}
                                            <div className="d-flex align-items-center gap-3">
                                                {/* Toggle */}
                                                <div className="d-flex align-items-center">
                                                    <Label className="me-2 mb-0">Assign Task</Label>

                                                    <div className="form-switch form-switch-md">
                                                        <input
                                                            title="Assign Tasks"
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="customSwitchsizemd"
                                                            checked={isNote}
                                                            onClick={(e) => setIsNote(!e.target.checked)}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Buttons */}
                                                <a
                                                    className="btn btn-save btn-label"
                                                    type="button"
                                                    href={`${configure.appUrl}calender/lead-${lead_id}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <i className="fa fa-users me-2 label-icon"></i>
                                                    Add Meeting
                                                </a>

                                                <button className="btn btn-save btn-label">
                                                    <i className="fas fa-plus me-2 label-icon"></i>
                                                    {isNote ? "Add Note & Task" : "Add Note"}
                                                </button>
                                            </div>
                                        </div>

                                        {/* ================= Task Toggle ================= */}
                                        {/* <div className="text-end me-3 align-items-center d-flex">
                          <Label htmlFor="formrow-firstname-Input">
                            Assign Task
                          </Label>
                          <div className="form-switch form-switch-md mb-2 mt-1">
                            <input
                              title="Assign Tasks"
                              type="checkbox"
                              className="form-check-input"
                              id="customSwitchsizemd"
                              // onClick={e => e.stopPropagation()}
                              checked={isNote || false}
                              onClick={e => setIsNote(!e.target.checked)}
                            />
                          </div>
                        </div> */}

                                        {/* ================= Task Fields ================= */}
                                        {isNote && (
                                            <div className="col-12 mt-3">
                                                <div className="row">
                                                    <div className="col-12 mb-3">
                                                        <label>
                                                            Enter Task Name{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Task Name"
                                                            value={taskName}
                                                            onChange={(e) => setTaskName(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="col-4 mb-3">
                                                        <label>
                                                            Assignee <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            placeholder="Select Assignee"
                                                            classNamePrefix="select"
                                                            options={alldependency?.users}
                                                            value={assignee}
                                                            onChange={(e) => setAssign(e)}
                                                        />
                                                    </div>

                                                    <div className="col-4 mb-3">
                                                        <label>
                                                            Priority <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            placeholder="Select Priority"
                                                            classNamePrefix="select"
                                                            options={priorityOption}
                                                            value={priority}
                                                            onChange={(e) => setPriority(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* ================= Description ================= */}
                                        <div className="mt-3" style={{ width: "98%" }}>
                                            <label htmlFor="">Description</label>
                                            <div
                                                className="no-drag"
                                                onDoubleClick={() => setNoDrag(true)}
                                                onMouseLeave={() => setNoDrag(false)}
                                                onMouseEnter={() => setNoDrag(true)}
                                            >
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={ckedata}
                                                    onReady={(editor) => { }}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        setCkedata(data);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Currency */}
                                        <div className="col-md-4 mt-3 px-0 ps-2">
                                            <label htmlFor="">Currency</label>
                                            <Select
                                                onChange={(e) =>
                                                    setCurrency({
                                                        label: e.label,
                                                        value: e.value,
                                                    })
                                                }
                                                placeholder="Select Currency"
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                styles={colourStyles}
                                                options={currency_option}
                                                menuPlacement="top"
                                            />
                                        </div>

                                        {/* Amount */}
                                        <div className="col-md-3 mt-3 px-0 ps-2">
                                            <label htmlFor="">Amount</label>
                                            <input
                                                type="number"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                placeholder="Enter Amount"
                                                className="form-control"
                                            />
                                        </div>

                                        {/* Got in touch date */}
                                        <div className="col-md-5 mt-3 notes pe-4">
                                            <label htmlFor="touch">
                                                Got in touch with this lead{" "}
                                                <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="datetime-local"
                                                value={notedate}
                                                onChange={(e) => setNotedate(e.target.value)}
                                                required
                                                className="form-control"
                                            />
                                        </div>

                                        {/* Attachment */}
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="">Attachment</label>

                                            <Dropzone
                                                onDrop={(acceptedFiles) => {
                                                    handleAcceptedFiles1(acceptedFiles);
                                                }}
                                            >
                                                {({ getRootProps, getInputProps }) => (
                                                    <div
                                                        className="dz-message needsclick p-0"
                                                        {...getRootProps()}
                                                    >
                                                        <input {...getInputProps()} />

                                                        <div className="d-flex px-2 custom-file-upload align-items-center">
                                                            <div>
                                                                <i className="display-6 text-muted bx bxs-cloud-upload" />
                                                            </div>
                                                            <h5 className="mb-0 ms-2">Upload Files</h5>
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        </div>

                                        {/* Uploaded Files Preview */}
                                        <div
                                            className={`col-md-5 mt-3 dropzone-previews ${selectedFiles1.length > 0 ? "d-block" : "d-none"
                                                }`}
                                            id="file-previews"
                                        >
                                            <label className="mb-1">Uploaded Files</label>

                                            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                                <div className="p-1">
                                                    <Row className="align-items-center justify-content-evenly">
                                                        {selectedFiles1.map((f, i) => {
                                                            return (
                                                                <Col key={i} className="col-auto">
                                                                    <img
                                                                        data-dz-thumbnail=""
                                                                        height="80"
                                                                        className="avatar-sm rounded bg-light"
                                                                        alt={f.name}
                                                                        src={f.preview}
                                                                    />
                                                                </Col>
                                                            );
                                                        })}
                                                    </Row>
                                                </div>
                                            </Card>
                                        </div>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Followup Model */}
            <Modal
                size="xl"
                isOpen={followupSidebar}
                toggle={() => {
                    followupSidebar();
                }}
                className="modal-fullscreen"
            >
                <div className="px-3">
                    {/* Row 1 — Title + Close Button */}
                    <div className=" modal-header d-flex justify-content-between align-items-center">
                        <h5 className="mt-0 head-move">Add Followup</h5>

                        <div className="company-info me-0 d-flex justify-content-center align-items-center">
                            <div className="d-flex justify-content-start align-items-center py-2 pt-3 gap-4">
                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-buildings-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.company}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-person-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.personName}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-telephone-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-end border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.phonenumber}
                                        </span>
                                    </h5>
                                </div>

                                <div>
                                    <h5>
                                        <i
                                            className="bi bi-envelope-fill text-purple"
                                            style={{ marginRight: "5px" }}
                                        ></i>
                                        <span className="border-3 border-dark pe-4 text-primary">
                                            {leadDetail?.email}
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => {
                                setFollowupSideBar(false);
                                setFilterFollowDate("");
                                setDescription("");
                                setNotedate("");
                                setAssign([]);
                                // fetch()
                            }}
                            className="btn-modal-close"
                        >
                            <span aria-hidden="true" className="btn-modal-span">
                                &times;
                            </span>
                        </button>
                    </div>

                    {/* Row 2 — Company Info */}

                    {/* Row 3 — Lead Description */}
                    <Row>
                        <Col>
                            <div
                                className="bg-light rounded-3 p-3"
                                style={{
                                    maxHeight: "120px",
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <div className="fw-bold text-dark mb-2">Lead Description:</div>
                                <div
                                    className="text-muted"
                                    style={{
                                        wordBreak: "break-word",
                                        lineHeight: "1.5",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            leadDetail?.description || "No description available.",
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* BODY */}
                <div
                    className="px-3 pt-2 bg-white modal-body"
                    style={{
                        // maxHeight: boxHeight - 100, // adjust as needed
                        overflowY: "auto",
                    }}
                >
                    <div className="row mt-4">
                        {/* ================= Left Side (Notes History) ================= */}
                        <div className="col-md-6">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <h5 className="text-dark">Followup History</h5>
                                <Select
                                    placeholder="Filter by date"
                                    isClearable
                                    value={filterFollowDate}
                                    className="basic-multi-select"
                                    classNamePrefix=" select"
                                    onChange={(e) => setFilterFollowDate(e)}
                                    options={[
                                        ...new Map(
                                            follow_data?.map((note) => {
                                                const d = moment(note.date_time).format("DD-MM-YYYY");
                                                return [
                                                    d,
                                                    {
                                                        label: d,
                                                        value: moment(note.date_time).format("YYYY-MM-DD"),
                                                    },
                                                ];
                                            }),
                                        ).values(),
                                    ]}
                                />
                            </div>
                            {/* <div
                    className="mt-4"
                    style={{
                      maxHeight: "450px",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}
                  > */}
                            <div
                                className="mt-4"
                                style={{
                                    maxHeight: boxHeight,
                                    overflowY: "auto",
                                    scrollbarWidth: "thin",
                                }}
                            >
                                <ul className="verti-timeline list-unstyled notes-box">
                                    {(filterFollowDate
                                        ? follow_data?.filter(
                                            (note) =>
                                                moment(note.date_time).format("YYYY-MM-DD") ===
                                                filterFollowDate?.value,
                                        )
                                        : follow_data
                                    )?.map((note, i) => {
                                        return (
                                            <li className="event-list position-relative" key={i}>
                                                <div className="event-timeline-dot connected-dot">
                                                    {note?.user_avatar ? (
                                                        <img
                                                            src={`${configure.imgUrl}/${note?.user_avatar}`}
                                                            className="msgUserImg me-3"
                                                            alt=""
                                                        />
                                                    ) : (
                                                        <div
                                                            className="defualt-img event-timeline-dot connected-dot"
                                                            title={note?.added_by}
                                                        >
                                                            {getInitials(note?.added_by || "Z")}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="d-flex">
                                                    <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div>
                                                                <p className="text-muted cursor-pointer">
                                                                    <h6 className="d-inline me-2">
                                                                        By {note.added_by}
                                                                    </h6>

                                                                    <Tooltip
                                                                        color="#f0e8f4"
                                                                        title={
                                                                            <div className="text-purple fw-bold body-font fs-6">
                                                                                <div>
                                                                                    UK Time:{" "}
                                                                                    {convertTimeZone(
                                                                                        note.created_at,
                                                                                        "Europe/London",
                                                                                        "DD-MM-YYYY hh:mm:ss a",
                                                                                    )}
                                                                                </div>

                                                                                <div>
                                                                                    US Time :{" "}
                                                                                    {moment(note.created_at)
                                                                                        .tz("America/New_York")
                                                                                        .format("DD-MM-YYYY hh:mm:ss a")}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    >
                                                                        {moment(note.created_at).format(
                                                                            "DD-MM-YYYY hh:mm:ss",
                                                                        )}
                                                                    </Tooltip>

                                                                    <h6 className="d-inline ms-3">
                                                                        Follow up at :
                                                                        <Tooltip
                                                                            color="#f0e8f4"
                                                                            className="ms-2"
                                                                            title={
                                                                                <div className="text-purple fw-bold body-font fs-6">
                                                                                    <div>
                                                                                        UK Time:{" "}
                                                                                        {convertTimeZone(
                                                                                            note.date_time,
                                                                                            "Europe/London",
                                                                                            "DD-MM-YYYY hh:mm:ss a",
                                                                                        )}
                                                                                    </div>

                                                                                    <div>
                                                                                        US Time :{" "}
                                                                                        {moment(note.date_time)
                                                                                            .tz("America/New_York")
                                                                                            .format("DD-MM-YYYY hh:mm:ss a")}
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        >
                                                                            {moment(note.date_time).format(
                                                                                "DD-MM-YYYY hh:mm:ss",
                                                                            )}
                                                                        </Tooltip>
                                                                    </h6>
                                                                    {/* <span className="pl-15">
                                    Got in touch with this lead at{" "}
                                    <Tooltip
                                      color="#f0e8f4"
                                      title={
                                        <div className="text-purple fw-bold body-font fs-6">
                                          <div>
                                            UK Time:{" "}
                                            {convertTimeZone(
                                              note.date,
                                              "Europe/London"
                                            )}
                                          </div>

                                          <div>
                                            US Time :{" "}
                                            {convertTimeZone(
                                              note.date,
                                              "America/New_York",
                                              "DD-MM-YYYY hh:mm:ss a"
                                            )}
                                          </div>
                                        </div>
                                      }
                                    >
                                      {moment(note.date).format(
                                        "DD-MM-YYYY hh:mm a"
                                      )}
                                    </Tooltip>
                                  </span> */}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <i className="bi bi-triangle-fill note-icon"></i>

                                                        {/* <p>
                              Description :
                            <div
                              className="Features word-wrap"
                              dangerouslySetInnerHTML={{
                                __html: note.description,
                              }}
                            />
                            </p> */}
                                                        <p className="mb-2">
                                                            Description : {note.description}{" "}
                                                        </p>

                                                        <p className="mb-2">
                                                            Asign User Name : {note.assign_user_name}{" "}
                                                        </p>

                                                        {note.link != null ? (
                                                            <p className="mb-1">
                                                                Attachment :{" "}
                                                                <a
                                                                    target="_blank "
                                                                    className="btn btn-sm edit-delete-btn text-secondary ml-10"
                                                                    rel="noreferrer"
                                                                    type="button"
                                                                    href={note.link}
                                                                >
                                                                    <i className="fas fa-eye"></i> View
                                                                </a>
                                                            </p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        {/* ================= Right Side (Add Note Form) ================= */}
                        <div
                            className="col-md-6"
                            style={{
                                maxHeight: boxHeight,
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                            }}
                        >
                            <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                                <Form onSubmit={addFollowup}>
                                    <Row className="align-items-center ">
                                        <div className="col-12 d-flex justify-content-between">
                                            <h5>Add New FollowUp</h5>
                                            <div className="text-end">
                                                <button className="btn btn-purple  me-2">
                                                    <i className="fas fa-plus me-2"></i>Add FollowUp
                                                </button>
                                                <a
                                                    onClick={() => {
                                                        setFollowupSideBar(false);
                                                        setDescription("");
                                                        setNotedate("");
                                                        setAssign([]);
                                                    }}
                                                    className="btn btn-red text-uppercase "
                                                >
                                                    <i className="dripicons-cross me-1 icon-center"></i>
                                                    Close
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mt-3 notes">
                                            <label htmlFor="touch">
                                                FollowUp Date <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                required
                                                value={notedate}
                                                onChange={(e) => setNotedate(e.target.value)}
                                                className="form-control "
                                            />
                                        </div>
                                        <div className="col-md-4 mt-4">
                                            <label htmlFor="">Assigned</label>
                                            <Select
                                                onChange={(e) => setAssign(e)}
                                                placeholder="Select"
                                                className="basic-multi-select"
                                                classNamePrefix=" select"
                                                value={assign}
                                                styles={colourStyles}
                                                isMulti
                                                options={assigned_data?.map((obj) => ({
                                                    label: obj.name,
                                                    value: obj.id,
                                                }))}
                                            />
                                        </div>

                                        <div className="col-12 mt-4">
                                            <label htmlFor="">Purpose</label>
                                            <textarea
                                                className="form-control"
                                                placeholder="Enter Purpose"
                                                onChange={(e) => setDescription(e.target.value)}
                                                style={{ height: "65px" }}
                                            ></textarea>
                                        </div>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* </ResizableBox>
        </Draggable>
      </div> */}
        </React.Fragment>
    );
};

export default Lead;
